import { LOCALES } from '../constants';
const pl = {
  [LOCALES.PL]: {
    //All page
    "Página não encontrada": "Strona nie znaleziona",
    //LOGIN
    "login.Login": "Zaloguj się",
    "login.Informe seu e-mail": "Podaj swój adres e-mail",
    "login.E-mail inválido. Por favor, verifique": "Nieprawidłowy adres e-mail. Proszę sprawdź",
    "login.Senha": "Hasło",
    "login.Sua senha deve possuir no mínimo 6 caracteres": "Twoje hasło musi mieć co najmniej 6 znaków",
    "login.Permanecer conectado": "Pozostań połączony",
    "login.Esqueci minha senha": "Zapomniałem hasła",
    "login.ENTRAR": "WPROWADŹ",
    "login.CRIAR CONTA": "UTWÓRZ KONTO",
    "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente": "Nie udało się zalogować. Sprawdź swoje dane i spróbuj ponownie",
    "login.Solicitar Acesso": "Żądanie dostępu",
    "login.Utilize esta opção caso possua apenas fornos da versão antiga, que não geram PIN.": "Skorzystaj z tej opcji, jeśli masz tylko stare wersje piekarników, które nie generują PIN-u.",
    "login.A PLATAFORMA IOK MUDOU!": "PLATFORMA IOK ZMIENIŁA SIĘ!",
    "login.Não exibir este aviso novamente": "Nie pokazuj tego komunikatu ponownie",
    "login.Se você já possui um cadastro na antiga plataforma,": "Jeśli masz już rejestrację na poprzedniej platformie,",
    "login.clique aqui": "kliknij tutaj",
    "login. para migrar seus dados e aproveitar toda a experiência IOK.": ", aby przenieść swoje dane i cieszyć się pełnym doświadczeniem IOK.",
    "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação": "Twoje konto nie zostało aktywowane. Proszę zweryfikuj swój e-mail, aby je aktywować",
    "login.Para solicitar acesso a uma organização, o nome informado por você deve ser exatamente o mesmo cadastrado pelo administrador da conta. Em caso de dúvida, procure o responsável pela rede.": "Aby poprosić o dostęp do organizacji, podane przez Ciebie imię musi być dokładnie takie samo, jak zarejestrowane przez administratora konta. W razie wątpliwości, wyszukaj odpowiednią instytucję.",
    "login.Se você já possui um cadastro na antiga plataforma, ": "Jeżeli posiadasz już rejestrację na starej platformie, ",
    "login. para": " do ",
    "login.migrar": "migrować ",
    "login.seus dados e aproveitar toda a experiência IOK.": "swoje dane i ciesz się pełnym doświadczeniem IOK.",
    "login.PLATAFORMA EM MANUTENÇÃO": "PLATFORMA W KONSERWACJI",
    "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "PRZYGOTUJEMY NOWĄ PLATFORMĘ IOK I JUŻ WKRÓTCE BĘDZIE GOTOWA!",
    "login.Migrar Conta": "Konto migracyjne",
    "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "Jeśli masz już rejestrację na starej platformie, kliknij tutaj Migracja konta, aby przeprowadzić migrację danych i cieszyć się całym doświadczeniem IOK",
    "login.Política de privacidade": "Polityka prywatności",
    "login.ENTENDI": "OK",
    "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "Używamy plików cookie, aby poprawić Twoje doświadczenia na platformie i oferować spersonalizowane usługi.",
    "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "Korzystając z Platformy IOK automatycznie wyrażasz zgodę na jej używanie.",
    "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "Nieprawidłowe hasło! Pozostały dwie próby przed zablokowaniem dostępu do konta.",
    "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "Nieprawidłowe hasło! Pozostała jedna próba przed zablokowaniem dostępu do konta.",
    "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "Dostęp zablokowany! Postępuj zgodnie z instrukcjami odzyskiwania konta.",
    
    //REGISTER
    "DISTRIBUIDOR": "DYSTRYBUTOR: Jestem dystrybutorem sprzętu Prática.",
    "REDE": "SIEĆ: Mam sieć.",
    "DONO": "FIRMA: Mam własną firmę/Jestem częścią sieci.",
    "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "Podaj swój e-mail zarejestrowany na poprzedniej platformie IOK",
    "register.E-mail inválido. Por favor, verifique": "Nieprawidłowy adres e-mail. Proszę sprawdź",
    "register.BUSCAR DADOS": "SZUKAJ DANYCH",
    "register.Nome da organização": "Nazwa organizacji",
    "register.Informe o nome de sua organização": "Podaj nazwę swojej organizacji",
    "register.O campo nome da organização é obrigatório": "Pole nazwy organizacji jest wymagane",
    "register.Este nome já existe. Por favor, escolha outro": "Ta nazwa już istnieje. Proszę wybrać inną",
    "register.RECUPERAR CONTA": "ODZYSKAJ KONTO",
    "register.E-mail não encontrado": "E-mail nie znaleziony",
    "register.Digite seu e-mail da plataforma IOK antiga": "Wprowadź swój e-mail z poprzedniej platformy IOK",
    "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "Nie udało się odzyskać twojego konta. Sprawdź swoje dane i spróbuj ponownie",
    "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "Nie udało się odzyskać twoich danych. Sprawdź i spróbuj ponownie",
    "register.PROSSEGUIR": "KONTYNUUJ",
    "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO": "PROSZISZ O DOSTĘP DO ORGANIZACJI:",
    "register.COM O ADMINISTRADOR": "Z ADMINISTRATOREM:",
    "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "E-mail już zarejestrowany na platformie. Podaj nowy adres e-mail lub zaloguj się na platformie za pomocą już zarejestrowanego",
    "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "Firma już zarejestrowana na platformie. Proszę podać nową nazwę firmy",
    "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "NIE ROZPOZNAŁEŚ UŻYTKOWNIKA {userName} JAKO CZĘŚCI TWOJEJ ORGANIZACJI, W ZWIĄZKU Z CZYM KONTO ZOSTAŁO USUNIĘTE.",
    "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "NIE MOŻNA USUNĄĆ UŻYTKOWNIKA {userName}. PROSZĘ, SPRÓBUJ PONOWNIE PÓŹNIEJ.",
    "register.CONFIRMAR": "POTWIERDŹ",
    "register.Informe o ID da organização": "Podaj identyfikator organizacji",
    "register.O campo com ID é obrigatório": "Pole ID jest wymagane",
    "register.Ainda não tenho uma organização. Criar": "Nie mam jeszcze organizacji. Utwórz",
    "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "Podany identyfikator nie pasuje do żadnej firmy. Sprawdź i spróbuj ponownie",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "ADMINISTRATOR ORGANIZACJI OTRZYMA E-MAIL DO AKTYWACJI TWOJEGO KONTA UŻYTKOWNIKA. PROSZĘ CZEKAJ",
    "register.Este nome de franquia já possui uma conta ativa na plataforma": "Ta nazwa franczyzy ma już aktywne konto na platformie",
    "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente": "Nie udało się zarejestrować. Sprawdź swoje dane i spróbuj ponownie",
    "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR": "ODBĘDZIESZ E-MAIL DO ZAKOŃCZENIA REJESTRACJI I AKTYWACJI TWOJEGO KONTA ADMINISTRATORA",
    "register.Nome": "Imię",
    "register.Informe seu nome": "Wprowadź swoje imię",
    "register.O campo nome é obrigatório": "Pole imienia jest wymagane",
    "register.E-mail": "E-mail",
    "register.Informe seu e-mail": "Podaj swój adres e-mail",
    "register.E-mail inválido. Por favor, verifique novamente": "Nieprawidłowy adres e-mail. Proszę sprawdź",
    "register.Telefone": "Numer telefonu",
    "register.Informe seu telefone": "Podaj swój numer telefonu",
    "register.Crie sua senha": "Utwórz hasło",
    "register.Informe sua senha": "Podaj swoje hasło",
    "register.O campo senha deve conter no mínimo 6 caracteres": "Pole hasła musi mieć co najmniej 6 znaków",
    "register.Confirme sua senha": "Potwierdź hasło",
    "register.As senhas devem ser iguais": "Hasło musi być zgodne",
    "register.CRIAR CONTA": "UTWÓRZ KONTO",
    "register.CONTA ATIVADA COM SUCESSO": "KONTO AKTYWOWANE POMYŚLNIE",
    "register.ACESSAR": "DOSTĘP",
    "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA": "NIE UDAŁO SIĘ AKTYWOWAĆ TWOJEGO KONTA",
    "register.Digite seu telefone": "Podaj swój numer telefonu",
    "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "PROSZĘ CZEKAĆ, aż prześlemy Twoje dane. PROCES TEN POWINNO ZAJĄĆ KILKA MINUT. W PRZYPADKU DUŻEJ ILOŚCI DANYCH TRANSFER MOŻE TRWAĆ DO GODZINY.",
    "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "PRZENIESIONO DANE POMYŚLNIE! KLIKNIJ PONIŻEJ, ABY WEJŚĆ NA PLATFORMĘ.",
    "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "NIEPRAWIDŁOWY ADRES E-MAIL. SPRAWDŹ, CZY TWOJE KONTO JUŻ ZOSTAŁO AKTYWOWANE.",
    "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "Nowa platforma IOK ma teraz nowe formy dostępu, związane z rodzajem organizacji, w której pracujesz. Osoba odpowiedzialna za Twoją organizację musi przenieść główne konto firmy, stając się administratorem, podczas gdy reszta pracowników musi się do niego podłączyć, używając dostarczonego identyfikatora.",
    "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "Administrator naszej organizacji już przeniósł konto, i mamy identyfikator. Chcę przenieść moje dane użytkownika.",
    "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "Chcę przenieść konto naszej organizacji i zostać administratorem.",
    "register.Conta da organização já migrada": "Konto organizacji już przeniesione",
    "register.Migrar conta da organização": "Przenieś konto organizacji",
    "register.VOCÊ POSSUI MUITOS MENUS, NÃO CONSEGUIMOS REALIZAR A IMPORTAÇÃO AUTOMÁTICA. SUA CONTA SERÁ ATIVADA, PORÉM OS MENUS PRECISARÃO SER MIGRADOS MANUALMENTE.": "MASZ DUŻO MENU, NIE MOŻEMY WYKONAĆ AUTOMATYCZNEGO IMPORTU. TWOJE KONTO ZOSTANIE AKTYWOWANE, ALE MENU TRZEBA PRZEMIERZAĆ RĘCZNIE.",
    "register.PARA MIGRAR SEUS MENUS, APÓS O LOGIN, CLIQUE NO SEU NOME NO CANTO SUPERIOR DIREITO, CLIQUE EM EDITAR CONTA E DEPOIS EM IMPORTAR MENUS.": "ABY PRZENIEŚĆ SWOJE MENU, PO ZALOGOWANIU KLIKNIJ NA SWOJE IMIĘ W PRAWYM GÓRNYM ROGU, KLIKNIJ EDYTUJ KONTO, A NASTĘPNIE IMPORTUJ MENU.",
    "register.Atenção:": "Uwaga:",
    "register.apenas uma pessoa da organização pode criar a conta e, depois de ativá-la, convidar os demais usuários da empresa para acessá-la.": "tylko jedna osoba z organizacji może utworzyć konto i po jego aktywacji zaprosić pozostałych użytkowników firmy do dostępu.",
    "register.TOKEN DESENVOLVEDOR CANCELADO": "TOKEN DEWELOPERA ANULOWANY",
    "register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial": "Twoje hasło musi mieć od 8 do 20 znaków, zawierać jedną wielką literę, jedną małą literę, jedną cyfrę i jeden znak specjalny",
    
    //HOME
    "home.Menus disponíveis na plataforma": "Menu dostępne na platformie",
    "home.Criados na plataforma": "Utworzone na platformie",
    "home.Recebidos dos fornos": "Otrzymane z pieców",
    "home.Equipamentos vinculados": "Połączone urządzenia",
    "home.Total de receitas cadastradas": "Łączna liczba zarejestrowanych przepisów",
    "home.Receitas": "Przepisy",
    "home.Receitas em menus": "Przepisy w menu",
    "home.Em menus": "W menu",
    "home.Receitas salvas no Cookbook": "Przepisy zapisane w książce kucharskiej",
    "home.No Cookbook": "W książce kucharskiej",
    "home.Atualizações": "Aktualizacje",
    "home.Copa": "Copa",
    "home.Rocket": "Rocket",
    "home.Single Mag": "Single Mag",
    "home.Versão instalada": "Zainstalowana wersja",
    "home.Versão disponível": "Dostępna wersja",
    "home.Usuários cadastrados": "Zarejestrowani użytkownicy",
    "home.Aceitação pendente": "Oczekuje na akceptację",
    "home.Atualizado": "Zaktualizowane",
    "home.OLÁ": "CZEŚĆ",
    "home.É muito bom ter você aqui!": "To wspaniale, że tu jesteś!",
    "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "Dzięki Platformie IOK możesz zarządzać swoimi piekarnikami z dowolnego miejsca, tworzyć i zarządzać przepisami i menu, tworzyć kopie zapasowe, analizować dane ze swojego sprzętu i wiele więcej!",
    "home.Conheça a plataforma": "Odkryj platformę",
    "home.Taxa de erro por modelo": "Współczynnik błędów na model",
    "home.Erro": "Błąd",
    "home.Modelos em evidência": "Modele na pierwszym planie",
    "home.Modelos": "Modele",
    "home.Total de equipamentos vinculados": "Łączna liczba powiązanych urządzeń",
    "home.Total de equipamentos online": "Łączna liczba urządzeń online",
    "home.Equipamentos online": "Urządzenia online",
    "home.Países com Prática": "Kraje z Prática",
    "home.Países": "Kraje",
    "home.Aguarde enquanto carregamos os dados": "Proszę czekać, ładowanie danych",
    "home.Quase lá! Aguarde um pouco mais": "Prawie gotowe! Proszę chwilę poczekać",
    "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "CHCEMY POZNAĆ TWOJĄ OPINIĘ NA TEMAT",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "Bardzo cenimy Twój punkt widzenia, dlatego powstał ten formularz ankiety satysfakcji na Platformie {model}!",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "Nous apprécions grandement votre point de vue et c'est pourquoi ce formulaire d'enquête de satisfaction concernant la ligne {model} a été créé !",
    "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "Twoje odpowiedzi pomogą nam ulepszyć nasze usługi, zapewniając, że w dalszym ciągu zapewniamy najlepszą możliwą jakość usług",
    "home.Reserve uns minutinhos de seu dia e participe!": "Poświęć kilka minut swojego dnia i weź udział!",
    "home.Responder a pesquisa": "Odpowiedz na ankietę",
    "home.Vendas por Equipamento": "Sprzedaż według sprzętu",
    "home.Total de equipamentos vendidos": "Łączna sprzedaż sprzętu",
    "home.Equipamentos vendidos": "Sprzedany sprzęt",
    "home.Clique para atualizar o software": "Kliknij, aby zaktualizować oprogramowanie",
    "home.Aceitação de software pendente": "Oczekuje na akceptację oprogramowania",
    "home.Software atualizado": "Oprogramowanie zaktualizowane",
    "home.NENHUM EQUIPAMENTO VINCULADO": "BRAK POWIĄZANEGO URZĄDZENIA",
    "home.FORNOS LIGADOS": "PIECE WŁĄCZONE",
    "home.Enviando dados": "Wysyłanie danych",
    "home.Sem envio de dados": "Brak przesyłania danych",
    "home.Criados na Plataforma": "Utworzone na Platformie",
    "home.Apenas no Cookbook": "Tylko w książce kucharskiej",
    "home.Usuários na companhia": "Użytkownicy w firmie",
    "home.Inativos": "Nieaktywni",
    "home.Online": "Online",
    "home.Atualizações de equipamentos": "Aktualizacje urządzeń",
    "home.Modelos de equipamentos": "Modele urządzeń",
    "home.Atualizados": "Zaktualizowane",
    "home.Aguardando Aceite": "Oczekujące akceptacji",
    "home.Desatualizados": "Niezaktualizowane",
    "home.Versão": "Wersja",
    "home.Recente": "Najnowsza",
    "home.Legenda": "Objaśnienia",
    "home.Chat": "Wsparcie",
    
    //MAIN
    "main.HOME": "STRONA GŁÓWNA",
    "main.COOKBOOK": "KSIĄŻKA KUCHARSKA",
    "main.MEUS MENUS": "MOJE MENU",
    "main.EQUIPAMENTOS": "SPRZĘT",
    "main.USUÁRIOS": "UŻYTKOWNICY",
    "main.ATENDIMENTOS": "USŁUGI",
    "main.Idioma": "Język",
    "main.Editar conta": "Edytuj konto",
    "main.Configurações": "Ustawienia",
    "main.Sair": "Wyloguj się",
    "main.Configurações salvas com sucesso!": "Ustawienia zapisane pomyślnie!",
    "main.SALVAR": "ZAPISZ",
    "main.CONFIGURAÇÕES": "USTAWIENIA",
    "main.Tema dark": "Ciemny motyw",
    "main.Notificações": "Powiadomienia",
    "main.Informações para as receitas": "Informacje o przepisie",
    "main.Peso:": "Waga",
    "main.Gramas": "Gramy",
    "main.Oz": "Uncje",
    "main.Temperatura:": "Temperatury:",
    "main.Celsius (°C)": "Celsjusz (°C)",
    "main.Fahrenheit (°F)": "Fahrenheit (°F)",
    "main.Conta editada com sucesso!": "Konto edytowane pomyślnie!",
    "main.EDITAR CONTA": "EDYTUJ KONTO",
    "main.Nome": "Imię",
    "main.Preencha com o seu nome": "Wypełnij swoje imię",
    "main.Telefone": "Telefon",
    "main.Preencha com o seu telefone": "Wypełnij swój numer telefonu",
    "main.E-mail": "E-mail",
    "main.Preencha com o seu e-mail": "Wypełnij swój adres e-mail",
    "main.Alterar Senha": "Zmień hasło",
    "main.ALTERAR SENHA": "ZMIEŃ HASŁO",
    "main.Senha atual": "Aktualne hasło",
    "main.Nova senha": "Nowe hasło",
    "main.Confirmar nova senha": "Potwierdź nowe hasło",
    "main.Informe sua senha atual": "Wprowadź swoje aktualne hasło",
    "main.O campo senha deve conter no mínimo 6 caracteres": "Pole hasła musi mieć co najmniej 6 znaków",
    "main.Informe sua nova senha": "Wprowadź nowe hasło",
    "main.Confirme sua nova senha": "Potwierdź nowe hasło",
    "main.Sua nova senha deve conter no mínimo 6 caracteres": "Twoje nowe hasło musi mieć co najmniej 6 znaków",
    "main.INFORME SUA SENHA": "WPISZ SWOJE HASŁO",
    "main.Informe sua senha para realizar a alteração de e-mail da plataforma:": "Wprowadź swoje hasło, aby zmienić swój adres e-mail na platformie:",
    "main.CONFIRMAR": "POTWIERDŹ",
    "main.Existem campos que não foram preenchidos corretamente": "Są pola, które nie zostały poprawnie wypełnione",
    "main.Informe sua senha para prosseguir com a alteração de e-mail": "Wprowadź swoje hasło, aby kontynuować zmianę swojego adresu e-mail",
    "main.Senha alterada com sucesso": "Hasło zostało pomyślnie zmienione",
    "main.Informe sua senha atual corretamente": "Wprowadź poprawnie swoje aktualne hasło",
    "main.As senhas devem ser iguais": "Hasła muszą być zgodne",
    "main.Nome do novo tipo de usuário": "Nowa nazwa rodzaju użytkownika",
    "main.Dê um nome para o novo tipo de usuário": "Nadaj nazwę nowemu rodzajowi użytkownika",
    "main.Token Desenvolvedor": "Token Dewelopera",
    "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "Token dewelopera to unikalny i nieprzekazywalny kod, który umożliwia wprowadzanie zmian na poziomie deweloperskim bezpośrednio w kodzie platformy za pomocą zewnętrznych interfejsów API. Pozwalają one na dostosowanie platformy, aby lepiej zaspokoić potrzeby Twojej firmy.",
    "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "Zaleca się, aby te zmiany zostały dokonane przez specjalistę z dziedziny technologii.",
    "main.Para acessar o token, informe sua senha": "Aby uzyskać dostęp do tokena, podaj swoje hasło.",
    "main.Copie e cole o token na autenticação de todas as requisições.": "Skopiuj i wklej token do uwierzytelniania wszystkich żądań.",
    "main.Seu Token": "Twój token",
    "main.Token copiado com sucesso!": "Token skopiowany pomyślnie!",
    "main.Você deseja cancelar o preenchimento das informações?": "Czy chcesz anulować wypełnianie informacji?",
    "main.Rever tutoriais": "Przegląd samouczków",
    "main.Tutoriais resetados com sucesso!": "Samouczki zostały pomyślnie zresetowane!",
    "main.review.tutorials": "Czy chcesz ponownie przejrzeć samouczki na platformie IOK?",
    "main.Procurar": "Szukać",
    "main.review.manual": "Możliwe jest również zapisanie go na komputerze.",
    "main.review.download": "Uzyskaj dostęp do podręcznika",
    
    //MENUS
    "menus.Procurar menu": "Menu wyszukiwania lub użytkownik",
    "menus.Procurar menu excluído": "Przeszukaj usunięte menu",
    "menus.Menus": "Menu",
    "menus.Lixeira": "Kosz",
    "menus.CRIAR MENU": "UTWÓRZ MENU",
    "menus.IMPORTAR MENU": "IMPORTUJ MENU",
    "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.": "Pliki będą przechowywane w koszu przez 30 dni od daty usunięcia. Po tym okresie zostaną trwale usunięte.",
    "menus.VOLTAR": "POWRÓT",
    "menus.Compatível com: ": "Zgodność z: ",
    "menus.Última atualização: ": "Ostatnia aktualizacja: ",
    "menus.Última atualização": "Ostatnia aktualizacja",
    "menus.EXPORTAR MENU": "EKSPORTUJ MENU",
    "menus.EDITAR MENU": "EDYTUJ MENU",
    "menus.Equipamentos associados": "Powiązane wyposażenie",
    "menus.Grupos": "Grupy",
    "menus.Procurar grupo": "Przeszukaj grupę",
    "menus.CRIAR GRUPO": "UTWÓRZ GRUPĘ",
    "menus.receitas": "Przepisy",
    "menus.Nenhum grupo cadastrado": "Brak zarejestrowanych grup",
    "menus.Nenhum menu cadastrado": "Brak zarejestrowanych menu",
    "menus.Nome": "Nazwa",
    "menus.Modelo": "Model",
    "menus.Atividade": "Aktywność",
    "menus.Associação": "Powiązanie",
    "menus.Exportar": "Eksport",
    "menus.Editar": "Edytuj",
    "menus.Excluir": "Usuń",
    "menus.Equips": "Wyposaż",
    "menus.Receitas": "Przepisy",
    "menus.Compatibilidade": "Zgodność",
    "menus.Versão": "Wersja",
    "menus.Origem": "Pochodzenie",
    "menus.Excluído por": "Usunięte przez",
    "menus.Data de exclusão": "Data usunięcia",
    "menus.Restaurar": "Przywróć",
    "menus.Existem campos que não foram preenchidos": "Istnieją pola, które nie zostały wypełnione",
    "menus.Menu criado com sucesso!": "Menu zostało utworzone pomyślnie!",
    "menus.Existem campos com informações inválidas": "Istnieją pola z nieprawidłowymi informacjami",
    "menus.SALVAR": "ZAPISZ",
    "menus.CANCELAR": "ANULUJ",
    "menus.Nome do menu": "Nazwa menu",
    "menus.Informe o nome do menu": "Podaj nazwę menu",
    "menus.Preencha o nome do menu sem caracteres especiais": "Wypełnij nazwę menu bez znaków specjalnych",
    "menus.Selecionar": "Wybierz",
    "menus.Idioma": "Język",
    "menus.Temperatura de pré-aquec 1": "Temperatura rozgrzewania 1",
    "menus.Informe a temperatura de pré-aquec 1": "Podaj temperaturę rozgrzewania 1",
    "menus.Temperatura de pré-aquec 2": "Temperatura rozgrzewania 2",
    "menus.Informe a temperatura de pré-aquec 2": "Podaj temperaturę rozgrzewania 2",
    "menus.Tempo para estabilização": "Czas stabilizacji",
    "menus.Informe o tempo para estabilização": "Podaj czas stabilizacji",
    "menus.Desativar pré-aquec 2": "Dezaktywuj rozgrzewanie 2",
    "menus.Configurações de data e hora": "Ustawienia daty i czasu",
    "menus.Data:": "Data:",
    "menus.DD/MM/AAAA": "DD/MM/YYYY",
    "menus.Hora:": "Godziny:",
    "menus.24h": "24h",
    "menus.AM/PM": "AM/PM",
    "menus.EUR: DD/MM/AAAA": "EUR: DD/MM/YYYY",
    "menus.USA: MM/DD/AAAA": "USA: MM/DD/YYYY",
    "menus.ISO: AAAA/MM/DD": "ISO: YYYY/MM/DD",
    "menus.Seleção de acessos para habilitar": "Wybór dostępu do włączenia",
    "menus.Modo manual": "Tryb manualny",
    "menus.Habilitado": "Możliwe",
    "menus.Desabilitado": "Wyłączone",
    "menus.Favoritos": "Ulubione",
    "menus.Aquecer/Dourar": "Nagrzewanie / Brązowanie",
    "menus.Repetir receita": "Powtórz przepis",
    "menus.Configurações gerais do menu": "Ogólne ustawienia menu",
    "menus.Temperatura": "Temperatura",
    "menus.Temperatura:": "Temperatura:",
    "menus.Celsius (°C)": "Celsjusz (°C)",
    "menus.Fahrenheit (°F)": "Fahrenheit (°F)",
    "menus.Peso": "Waga",
    "menus.Gramas": "Gramy",
    "menus.Oz": "Uncje",
    "menus.Tema:": "Motyw:",
    "menus.Dark": "Ciemny",
    "menus.Light": "Jasny",
    "menus.Introdução:": "Wprowadzenie:",
    "menus.Ativada": "Aktywowane",
    "menus.Desativada": "Dezaktywowane",
    "menus.Menu deletado com sucesso!": "Menu pomyślnie usunięte!",
    "menus.Não foi possivel deletar o menu": "Nie można usunąć menu",
    "menus.Sim": "Tak",
    "menus.Não": "Nie",
    "menus.Excluir definitivamente": "Trwale usuń",
    "menus.SALVAR NO DISPOSITIVO": "ZAPISZ NA URZĄDZENIU",
    "menus.EXPORTAR": "EKSPORTUJ",
    "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.": "Wybierz modele i wersje sprzętu, aby otrzymać menu",
    "menus.Forno": "Piekarnik",
    "menus.Fundo verde": "Zielone tło",
    "menus.Fundo preto": "Czarne tło",
    "menus.Linux": "Linux",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.": "Uwaga: przed przesłaniem menu z dysku flash do sprzętu, konieczne jest rozpakowanie pliku, z wyjątkiem menu dla sprzętu z systemem Linux.",
    "menus.Selecione os equipamentos para os quais deseja exportar o menu.": "Wybierz sprzęt, dla którego chcesz wyeksportować menu.",
    "menus.Nome do equipamento": "Nazwa sprzętu",
    "menus.Selecionar todos": "Zaznacz wszystko",
    "menus.Selecionar todas": "Zaznacz wszystko",
    "menus.Categoria: ": "Kategoria: ",
    "menus.Você deseja excluir o menu?": "Czy chcesz usunąć menu?",
    "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.": "Menu zostanie usunięte z platformy, ale pozostanie na sprzęcie. Automatycznie zostanie utworzona kopia zapasowa, dostępna przez 30 dni w Moje Menu - Kosz.",
    "menus.Você deseja excluir o arquivo definitivamente?": "Czy chcesz trwale usunąć plik?",
    "menus.Esta ação não poderá ser desfeita.": "Tej operacji nie można cofnąć.",
    "menus.Menu editado com sucesso!": "Menu pomyślnie edytowane!",
    "menus.IMPORTAR": "IMPORTUJ",
    "menus.VERIFICAÇÃO DE VERSÃO": "SPRAWDZANIE WERSJI",
    "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:": "Aby sprawdzić wersję płyty sprzętu, postępuj zgodnie z poniższymi krokami:",
    "menus.No forno, acesse Configurações;": "W piekarniku przejdź do Ustawień;",
    "menus.Insira a senha 456789;": "Wprowadź hasło 456789;",
    "menus.Selecione a opção Sistema;": "Wybierz opcję System;",
    "menus.Selecione Informações do Fabricante;": "Wybierz Informacje o producencie;",
    "menus.O modelo de sua placa estará na linha Firmware IHM;": "Model twojej płyty będzie widoczny w linii Firmware IHM;",
    "menus.1ª geração A": "1. generacja A",
    "menus.Firmware IHM: 12.3.4": "Firmware IHM: 12.3.4",
    "menus.1ª geração B": "1. generacja B",
    "menus.2ª geração/Linux:": "2. generacja/Linux",
    "menus.Firmware IHM: L1.2.3": "Firmware IHM: L1.2.3",
    "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento": "Wybierz model/wersję sprzętu, z którego chcesz zaimportować menu. Dowiedz się, jak sprawdzić wersję swojego sprzętu ",
    "menus.Selecione o modelo/versão do equipamento": "Wybierz model/wersję urządzenia",
    "menus.Como verificar a versão da placa": "Jak sprawdzić wersję płyty",
    "menus.1° Geração": "1. generacja",
    "menus.Menu restaurado com sucesso!": "Menu przywrócone pomyślnie!",
    "menus.Não foi possivel restaurar o menu": "Nie można przywrócić menu",
    "menus.RESTAURAR ARQUIVO": "PRZYWRÓĆ PLIK",
    "menus.Você deseja restaurar o arquivo?": "Czy chcesz przywrócić plik?",
    "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.": "Plik zostanie przywrócony jako nowa wersja na platformie w zakładce Wszystkie. Aby zapisać go na swoim urządzeniu, wyeksportuj go.",
    "menus.EXCLUIR MENU": "USUŃ MENU",
    "menus.Nenhum equipamento associado": "Brak powiązanego sprzętu",
    "menus.Nomeie o novo menu": "Nadaj nazwę nowemu menu",
    "menus.Nomeie o novo grupo": "Nadaj nazwę nowej grupie",
    "menus.Nome do grupo": "Nazwa grupy",
    "menus.Preencha o nome do grupo sem caracteres especiais": "Wypełnij nazwę grupy bez znaków specjalnych",
    "menus.Pré-aquecimento": "Rozgrzewanie",
    "menus.Pré-aquecimento:": "Rozgrzewanie:",
    "menus.Grupo criado com sucesso!": "Grupa utworzona pomyślnie!",
    "menus.SELECIONE UMA IMAGEM": "WYBIERZ OBRAZ",
    "menus.SELECIONAR": "WYBIERZ",
    "menus.Selecionar do dispositivo": "Wybierz z urządzenia",
    "menus.Selecionar do banco de imagens": "Wybierz z banku obrazów",
    "menus.Formato .JPG ou .PNG": "Format .JPG lub .PNG",
    "menus.Procurar imagem": "Przeszukaj obraz",
    "menus.Pertence ao menu": "Należy do menu",
    "menus.Alterar imagem": "Zmień obraz",
    "menus.Remover imagem": "Usuń obraz",
    "menus.EDITAR GRUPO": "EDYTUJ GRUPĘ",
    "menus.CRIAR RECEITA": "UTWÓRZ PRZEPIS",
    "menus.SALVAR DO COOKBOOK": "ZAPISZ Z KSIĄŻKI KUCHARSKIEJ",
    "menus.Procurar receita do grupo": "Przeszukaj przepisy grupy",
    "menus.Ingrediente principal": "Główny składnik",
    "menus.Limpar filtros": "Wyczyść filtry",
    "menus.Filtrar": "Filtrować",
    "menus.Mover receitas": "Przenieś przepisy",
    "menus.Excluir receitas": "Usuń przepisy",
    "menus.Editar grupo": "Edytuj grupę",
    "menus.Excluir grupo": "Usuń grupę",
    "menus.aqui": "tutaj",
    "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.": "Jeśli kod zawiera tylko liczby, a tło jest zielone, należy do 1. generacji A; jeśli zawiera tylko liczby, a tło jest czarne, należy do 1. generacji B; jeśli zaczyna się od liter L, F lub S, płyta należy do 2. generacji/Linux.",
    "menus.1ª A - Fundo verde": "1. generacja A - Zielone tło",
    "menus.1ª B - Fundo preto": "1. generacja B - Czarne tło",
    "menus.2ª - Linux": "2. generacja - Linux",
    "menus.Tivemos um problema. Tente novamente mais tarde.": "Wystąpił problem. Spróbuj ponownie później.",
    "menus.Grupo editado com sucesso!": "Grupa edytowana pomyślnie!",
    "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "TUTAJ JESZCZE NIE MA GRUP :(",
    "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "Kliknij przycisk znajdujący się w prawym górnym rogu i dodaj grupy.",
    "menus.NENHUM MENU NA LIXEIRA": "BRAK MENU W KOSZU",
    "menus.AINDA NÃO HÁ MENUS AQUI :(": "TUTAJ JESZCZE NIE MA MENU :(",
    "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "Kliknij jeden z przycisków znajdujących się w prawym górnym rogu i dodaj menu.",
    "menus.Adicionar imagem": "Dodaj obraz",
    "menus.Nome da receita": "Nazwa przepisu",
    "menus.Origem da receita": "Pochodzenie przepisu",
    "menus.Detalhes da receita": "Szczegóły przepisu",
    "menus.Programação da receita": "Programowanie przepisu",
    "menus.Nomeie sua receita": "Nadaj nazwę swojemu przepisowi",
    "menus.Preencha o nome da receita sem caracteres especiais": "Wypełnij nazwę przepisu bez znaków specjalnych",
    "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "Dozwolone są tylko znaki @#%&*-+()!\"<>:;\/?.",
    "menus.Tipo de prato": "Typ posiłku",
    "menus.SALVAR RECEITAS DO COOKBOOK": "ZAPISZ PRZEPISY Z KSIĄŻKI KUCHARSKIEJ",
    "menus.Selecione as receitas que deseja salvar no grupo de seu menu:": "Wybierz przepisy, które chcesz zapisać w grupie swojego menu:",
    "menus.Procurar receita": "Przeszukaj przepis",
    "menus.deleteGroupSuccess":
    "{count, plural, one {Grupa została pomyślnie usunięta!} other {Grupy zostały pomyślnie usunięte!}}",
    "menus.deleteGroupError":
    "{count, plural, one {Nie udało się usunąć grupy} other {Nie udało się usunąć grupy}}",
    "menus.EXCLUIR GRUPO": "USUŃ GRUPĘ",
    "menus.confirmDeleteGroupMessage":
    "{count, plural, one {Czy chcesz trwale usunąć grupę?} other {Czy chcesz trwale usunąć grupy?}}",
    "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "TUTAJ JESZCZE NIE MA PRZEPISÓW :(",
    "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "Kliknij jeden z przycisków znajdujących się w prawym górnym rogu i dodaj przepisy.",
    "menus.Temp. de entrada": "Temperatura początkowa",
    "menus.Temp. de pré-aquec": "Temperatura rozgrzewania",
    "menus.Ingredientes para montagem": "Składniki do złożenia",
    "menus.Instruções operacionais": "Instrukcje obsługi",
    "menus.Passo": "Krok",
    "menus.Temp": "Temp ",
    "menus.Temp.": "Temp. ",
    "menus.Tempo": "Czas",
    "menus.Velocidade do ar": "Prędkość powietrza",
    "menus.Micro-ondas": "Mikrofalówka",
    "menus.Resistência inferior": "Odporność dolna",
    "menus.Informações": "Informacje",
    "menus.Digite as informações do passo": "Wprowadź informacje o kroku",
    "menus.desativar": "dezaktywuj",
    "menus.Ingredientes": "Składniki",
    "menus.Temperatura de entrada": "Temperatura początkowa",
    "menus.Equipamentos compatíveis": "Zgodny sprzęt",
    "menus.Tempo total": "Czas całkowity",
    "menus.SALVAR NO COOKBOOK": "ZAPISZ W KSIĄŻCE KUCHENNEJ",
    "menus.ver localização": "zobacz lokalizację",
    "menus.SELECIONE RECEITAS PARA EXCLUIR": "WYBIERZ PRZEPISY DO USUNIĘCIA",
    "menus.Você deseja excluir as receitas selecionadas definitivamente": "Czy chcesz definitywnie usunąć wybrane przepisy?",
    "menus.Receitas deletadas com sucesso!": "Przepisy zostały pomyślnie usunięte!",
    "menus.Informe aqui os ingredientes para montagem": "Podaj tutaj składniki do montażu",
    "menus.Informe aqui as instruções operacionais": "Podaj tutaj instrukcję obsługi",
    "menus.Adicionar passo": "Dodaj krok",
    "menus.Receita criada com sucesso!": "Przepis został utworzony pomyślnie!",
    "menus.Ideal para:": "Idealne dla: ",
    "menus.editar detalhes": "edytować szczegóły",
    "menus.excluir": "usuwać",
    "menus.editar": "edytować",
    "menus.Receita editada com sucesso!": "Przepis został pomyślnie edytowany!",
    "menus.Passo deletado com sucesso!": "Krok został pomyślnie usunięty!",
    "menus.Não foi possivel deletar o passo": "Nie można usunąć kroku",
    "menus.EXCLUIR PASSO": "USUŃ KROK",
    "menus.Você deseja excluir este passo": "Czy chcesz usunąć ten krok?",
    "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.": "Tej akcji nie można cofnąć. Jeśli wolisz, możesz ją jedynie dezaktywować, zachowując ustawienia. ",
    "menus.Plataforma": "Platforma",
    "menus.Receita salva com sucesso!": "Przepis został pomyślnie zapisany!",
    "menus.Exportar receitas": "Eksportuj przepisy",
    "menus.expandir": "zwiększać",
    "menus.Vapor combinado": "Połączona para",
    "menus.Ar quente": "Gorące powietrze",
    "menus.Sonda": "Sonda",
    "menus.Tempo (min)": "Czas (min)",
    "menus.Umidade (%)": "Wilgotność (%)",
    "menus.Injeção de vapor": "Wtrysk pary",
    "menus.Dumper aberto": "Otwórz wywrotkę",
    "menus.Informe o peso": "Poinformuj o wadze",
    "menus.Informe a temperatura de entrada": "Podaj temperaturę początkową",
    "menus.Informe os ingredientes para montagem": "Wprowadź składniki do montażu",
    "menus.Informe as instruções operacionais": "Wprowadź instrukcje obsługi",
    "menus.Injeção de vapor (seg)": "Wstrzymanie pary (s)",
    "menus.Aquecer mais": "Rozgrzewanie więcej",
    "menus.Dourar mais": "Brązowienie więcej",
    "menus.Aquecer e dourar mais": "Rozgrzewanie i brązowienie więcej",
    "menus.Favoritar receita": "Ulubiony przepis",
    "menus.Apenas favoritos": "Tylko ulubione",
    "menus.Forno combinado": "Kombinowana kuchenka",
    "menus.Cocção múltipla": "Wielokrotne gotowanie",
    "menus.Receitas Technicook": "Przepisy Technicook",
    "menus.Editar grupos": "Edytuj grupy",
    "menus.Informe a data": "Podaj datę",
    "menus.Informe a hora": "Podaj godzinę",
    "menus.até 300": "do 300",
    "menus.Vapor": "Para",
    "menus.Turbina": "Turbina",
    "menus.Criar grupo": "Utwórz grupę",
    "menus.MOVER": "PRZENIEŚ",
    "menus.Configurações de acessos": "Ustawienia dostępu:",
    "menus.SELECIONE RECEITAS PARA MOVER": "WYBIERZ PRZEPISY DO PRZENIESIENIA",
    "menus.AVANÇAR": "DALEJ",
    "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.": "Wybierz lub utwórz grupę w tym samym menu, aby przenieść wybrane przepisy lub przenieś je do innego menu. Zauważ, że będą wyświetlane tylko te menu/grupy, które są kompatybilne z ustawieniami przepisu.",
    "menus.Mover receitas para o mesmo menu": "Przenieś przepisy do tego samego menu",
    "menus.Mover receitas para outro menu": "Przenieś przepisy do innego menu",
    "menus.Selecionar grupo": "Wybierz grupę",
    "menus.Nenhuma receita foi selecionada": "Nie wybrano żadnego przepisu",
    "menus.Passo editado com sucesso!": "Krok pomyślnie edytowany!",
    "menus.Menu atualizado": "Menu zaktualizowane",
    "menus.até 260": "do 260",
    "menus.Umidade na câmara": "Wilgotność komory",
    "menus.Passos": "Kroki",
    "menus.ativar": "aktywuj",
    "menus.Informe a temperatura de pré-aquec": "Podaj temperaturę rozgrzewania",
    "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.": "Przenieś wybrane przepisy do innego menu. Zauważ, że będą wyświetlane tylko te menu, które są kompatybilne z ustawieniami przepisu.",
    "menus.Sonda (°C)": "Sonda (ºC)",
    "menus.Turbo Grill": "Turbo Grill",
    "menus.Pré-aquecimento padrão, conforme passo 1": "Standardowe rozgrzewanie, zgodnie z krokiem 1",
    "menus.salvar": "zapisz",
    "menus.até": "do",
    "menus.Verificação de receita": "Sprawdzenie przepisu",
    "menus.Auto import": "Automatyczny import",
    "menus.Atualização forçada": "Wymuszone aktualizacje",
    "menus.Lista de receitas exportada com sucesso!": "Lista przepisów pomyślnie wyeksportowana!",
    "menus.Receita movida com sucesso!": "Przepis przeniesiony pomyślnie!",
    "menus.Receitas movidas com sucesso!": "Przepisy przeniesione pomyślnie!",
    "menus.+ Receita": "Przepis",
    "menus.Escolha um idioma compatível com o equipamento": "Wybierz język kompatybilny z wyposażeniem",
    "menus.MENU IMPORTADO COM SUCESSO!": "Menu zostało pomyślnie zaimportowane!",
    "menus.Dourar": "Brązowy",
    "menus.Não atribuir a menu": "Nie przypisuj do menu",
    "menus.Todos": "Wszystkie",
    "menus.Meus menus": "Moje Menu",
    "menus.Para salvar uma receita, preencha todos os campos": "Aby zapisać przepis, wypełnij wszystkie pola",
    "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "Wybierz grupy urządzeń, dla których chcesz wyeksportować menu.",
    "menus.Você deseja excluir este passo?": "Czy chcesz usunąć ten krok?",
    "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "Nieprawidłowy format. Dozwolone są tylko formaty .jpeg i .png.",
    "menus.Reordenar grupos": "Sortowanie grup",
    "menus.O que deseja fazer?": "Co chcesz zrobić?",
    "menus.Reordenar receitas": "Sortowanie przepisów",
    "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ALTERAÇÕES NO FORNO, EXPORTE O MENU.": "ELEMENTY ZMODYFIKOWANE POMYŚLNIE! ABY ZASTOSOWAĆ ZMIANY W PIEKARNIKU, WYEXPORTUJ MENU.",
    "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "Przeciągnij elementy w żądane miejsce.",
    "menus.Dumper": "Wywrotka",
    "menus.Aberto": "otwarty",
    "menus.Fechado": "Zamknięte",
    "menus.Intermitente": "Przerywany",
    "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "Jeśli Twoje menu zawiera pozycje wrażliwe na jednolitość, zalecamy ustawienie Czasu Stabilizacji między 3:00 a 5:00 minut. W przeciwnym razie możesz pozostawić go na 5 sekund.",
    "menus.Selecione o menu que deseja exportar:": "Wybierz menu, które chcesz wyeksportować:",
    "menus.Temperatura de pré-aquecimento": "Temperatura rozgrzewania",
    "menus.Temperatura de lastro": "Temperatura balastu",
    "menus.Temperatura de teto": "Temperatura sufitu",
    "menus.Volume de injeção de vapor (ml)": "Objętość wtrysku pary (ml)",
    "menus.Parada de turbina": "Zatrzymanie turbiny",
    "menus.Alta": "Wysoka",
    "menus.Média": "Średnia",
    "menus.Baixa": "Niska",
    "menus.a": "the",
    "menus.Valor da injeção": "Wartość wtrysku",
    "menus.Volume: até 999ml": "Objętość: do 999ml",
    "menus.Tempo: até 15 segundos": "Czas: do 15 sekund",
    "menus.Tempo de injeção de vapor (seg)": "Czas wtrysku pary (sek)",
    "menus.Atenção!": "Uwaga!",
    "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "Sprawdź przepisy menu i dostosuj wartości wtrysku pary po zmianie jednostki miary.",
    "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "Upewnij się, że jednostka temperatury (°C lub °F) zdefiniowana na urządzeniu jest taka sama, jak wybrana podczas tworzenia menu:",
    "menus.Injeção desativada": "Wtrysk wyłączony",
    "menus.Selecione a unidade de temperatura que está definida no equipamento:": "Wybierz jednostkę temperatury zdefiniowaną na urządzeniu:",
    "menus.Clique para atualizar": "Kliknij, aby zaktualizować",
    "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "Funkcja Wymuszona Aktualizacja automatycznie wysyła menu do wybranego sprzętu, który posiada wersję zgodną z tego typu aktualizacją, przy kolejnym włączeniu. Piece, które nie zostały zmodernizowane, nadal będą musiały zostać poddane ręcznemu odbiorowi.",
    "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "Wybrane opcje będą dostępne na sprzęcie, który otrzyma to menu i mogą być używane przez operatora. Ustawienia te można później zmienić w samym piekarniku lub za pośrednictwem platformy.",
    "menus.+ Menu": "+ Menu",
    "menus.Não foi possivel deletar as receitas": "Nie można usunąć przepisów",
    "menus.PRÉ": "PRZED",
    "menus.Speed Ovens": "Speed Ovens",
    "menus.Fornos Combinados": "Piece Kombinowane",
    "menus.Fornos de Panificação": "Piece do Piekarnictwa",
    "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "Po utworzeniu typ menu nie może zostać zmieniony. Może być ustawiony tylko w momencie tworzenia.",
    "menus.Pré-aquecimento do grupo": "Podgrzewanie grupowe",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "Uwaga: przed przeniesieniem menu z pendrive'a na sprzęt należy rozpakować plik przenosząc folder PRATICA na sprzęt.",
    "menus.Tamanho máximo": "Maksymalny rozmiar",
    "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "Umożliwia operatorowi pieca tworzenie parametrów i ich późniejsze wykonanie.",
    "menus.Acesso também à execução das receitas favoritas.": "Zapewnia również dostęp do wykonania ulubionych przepisów.",
    "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "Umożliwia operatorowi dodanie więcej czasu na podgrzanie/przyrumienienie posiłku po jego wykonaniu.",
    "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "Umożliwia powtórzenie przepisu zaraz po jego wykonaniu.",
    "menus.Acesso exclusivo às receitas favoritas.": "Wyłączny dostęp do ulubionych przepisów.",
    "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "Umożliwia przypomnienie operatorowi o sprawdzeniu, czy jedzenie znajduje się już w piecu.",
    "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "Piec automatycznie importuje menu zapisane na pendrive po włączeniu.",
    "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "Umożliwia jednoczesne gotowanie różnych potraw, każda w osobnym GN.",
    "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "Umożliwia wykonanie wstępnie zaprogramowanych przepisów fabrycznych.",
    "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "Umożliwia dostęp do funkcji turbo grill, która osiąga temperaturę do 300°C.",
    "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "Pozwala operatorowi dodać więcej czasu na przypieczenie potrawy po jej wykonaniu.",
    "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "Pozwala operatorowi edytować grupy przepisów bezpośrednio z ekranu głównego.",
    "menus.Copiar grupos": "Kopiuj grupy",
    "menus.Excluir grupos": "Usuń grupy",
    "menus.Copiar": "Kopiuj",
    "menus.Selecione grupos para copiar": "Wybierz grupy do skopiowania",
    "menus.Selecione o destino dos grupos": "Wybierz miejsce docelowe dla grup",
    "menus.Colar": "Wklej",
    "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "Czy chcesz anulować kopiowanie i wysyłanie grup do menu?",
    "menus.Grupos colados com sucesso": "{count, plural, one {Grupa została pomyślnie wklejona!} other {Grupy zostały pomyślnie wklejone!}}",
    "menus.Copiar receitas": "Kopiuj przepisy",
    "menus.Selecione receitas para copiar": "Wybierz przepisy do skopiowania",
    "menus.Selecione o destino das receitas": "Wybierz miejsce docelowe dla przepisów",
    "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "Czy chcesz anulować kopiowanie i wysyłanie przepisów do grup?",
    "menus.Receitas coladas com sucesso": "{count, plural, one {Przepis został pomyślnie wklejony!} other {Przepisy zostały pomyślnie wklejone!}}",
    "menus.Converter para C-MAX EVO": "Konwertuj na C-MAX EVO",
    "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "Zostanie utworzona kopia tego menu, dostosowana do C-MAX EVO. Zalecamy dokładne sprawdzenie wszystkich parametrów kroków i zaktualizowanie przepisów o nowe obrazy, jeśli to konieczne.",
    "menus.Menu convertido com sucesso!": "Menu zostało pomyślnie przekonwertowane!",
    "menus.Não foi possível converter o menu. Tente novamente mais tarde": "Nie udało się przekonwertować menu. Spróbuj ponownie później.",
    "menus.O menu está sendo convertido... Aguarde!": "Menu jest konwertowane... Proszę czekać!",
    "menus.Menu incompatível com": "Menu niekompatybilne z",
    "menus.Selecione pelo menos um grupo": "Wybierz przynajmniej jedną grupę",
    "menus.Selecione pelo menos um menu": "Wybierz przynajmniej jedno menu",
    "menus.Menu atual": "Aktualne menu",
    "menus.Copiando grupos": "{count, plural, one {Grupa jest kopiowana... Proszę czekać!} other {Grupy są kopiowane... Proszę czekać!}}",
    "menus.Erro ao copiar grupos": "{count, plural, one {Nie można skopiować grupy. Spróbuj ponownie później!} other {Nie można skopiować grup. Spróbuj ponownie później!}}",
    "menus.Procurar pelo nome do menu": "Szukaj według nazwy menu",
    "menus.Escolha um grupo de destino para cada menu selecionado": "Wybierz grupę docelową dla każdego wybranego menu!",
    "menus.Copiando receitas": "{count, plural, one {Przepis jest kopiowany... Proszę czekać!} other {Przepisy są kopiowane... Proszę czekać!}}",
    "menus.Erro ao copiar receitas": "{count, plural, one {Nie można skopiować przepisu. Spróbuj ponownie później!} other {Nie można skopiować przepisów. Spróbuj ponownie później!}}",
    "menus.SELECIONE GRUPOS PARA EXCLUIR": "WYBIERZ GRUPY DO USUNIĘCIA",
    "menus.Padeiro noturno": "Nocny piekarz",
    "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "Umożliwia zaprogramowanie startu (wstępnego nagrzewania) konkretnego przepisu lub wprowadzonego ręcznie (Tryb Ręczny), bez konieczności obecności operatora na miejscu.",
    "menus.Vaporizador": "Odparowalnik",
    "menus.Editar receitas": "Edytuj przepisy",
    "menus.Permite que o operador edite receitas diretamente da tela inicial.": "Umożliwia operatorowi edytowanie przepisów bezpośrednio z ekranu głównego.",
    "menus.Preencha o nome da receita": "Wpisz nazwę przepisu",
    "menus.Tempo nível": "Poziom czasu",
    "menus.Fermentadora": "Komora fermentacyjna",
    "menus.0 ou 5 a 59s": "0 lub od 5 do 59 s",
    "menus.Informe o tempo para aquecer mais":
    "Podaj czas dodatkowego podgrzewania",
    "menus.Informe o tempo para dourar mais":
    "Podaj czas dodatkowego przypiekania",
    "menus.Informe o tempo para aquecer e dourar mais":
    "Podaj czas dodatkowego podgrzewania i przypiekania",
    "menus.Selecione uma imagem": "Wybierz obraz",
    "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*Aby utworzyć przepisy dla pieców bez łączności, najpierw utwórz menu, a następnie przepisy.",
    "menus.CONVERTER": "KONWERTUJ",
    "menus.Converter para FIT": "Konwertuj do FIT",
    "menus.Selecione pelo menos um modelo FIT": "Wybierz co najmniej jeden model FIT",
    "menus.O menu está sendo convertido para FIT... Aguarde!": "Menu jest konwertowane do FIT... Proszę czekać!",
    "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} menu(a) zostało pomyślnie przekonwertowane do FIT!",
    "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "Niektóre menu zostały przekonwertowane, ale wystąpił błąd dla: {models}",
    "menus.Converter para outro FIT": "Konwertuj na inny FIT",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "Kopia tego menu zostanie utworzona dla każdego wybranego modelu FIT, zachowując konfiguracje, grupy, receptury i kroki.",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir najlepszą wydajność i rezultat dla każdego urządzenia. Selecione o modelo da linha FIT para qual deseja converter o menu." : "Kopia tego menu zostanie utworzona dla każdego wybranego modelu FIT, zachowując konfiguracje, grupy, receptury i kroki. Jednak ponieważ każdy piec posiada specyficzne wymiary i cechy, zalecamy sprawdzenie i dostosowanie parametrów, aby zapewnić najlepszą wydajność i rezultat dla każdego urządzenia. Wybierz model linii FIT, na który chcesz przekonwertować menu.",
    
    //COOKBOOK
    "cookbook.RECEITAS DISPONÍVEIS": "DOSTĘPNE PRZEPISY",
    "cookbook.RECEITAS SALVAS": "ZAPISANE PRZEPISY",
    "cookbook.ENVIAR PARA MENU": "WYŚLIJ DO MENU",
    "cookbook.SALVAR": "ZAPISZ",
    "cookbook.salvar": "zapisz",
    "cookbook.Filtrar por": "Filtruj według",
    "cookbook.Procurar receita do cookbook": "Wyszukaj przepis z książki kucharskiej",
    "cookbook.Equipamento": "Sprzęt",
    "cookbook.Ingrediente principal": "Główny składnik",
    "cookbook.Tipo de prato": "Rodzaj posiłku",
    "cookbook.Região": "Region",
    "cookbook.Pré-aquecimento": "Rozgrzewanie",
    "cookbook.Procurar receita": "Wyszukaj przepis",
    "cookbook.Menu": "Menu",
    "cookbook.ENVIAR": "WYŚLIJ",
    "cookbook.Procurar nome do menu": "Wyszukaj nazwę menu",
    "cookbook.Escolha um grupo deste menu": "Wybierz grupę z tego menu",
    "cookbook.Selecionar grupo": "Wybierz grupę",
    "cookbook.Tivemos um problema. Tente novamente mais tarde": "Mamy problem. Spróbuj ponownie później",
    "cookbook.Receita adicionada com sucesso!": "Przepis dodany pomyślnie!",
    "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde": "Nie udało się dodać przepisu. Spróbuj ponownie później",
    "cookbook.Selecione um menu e um grupo para enviar esta receita": "Wybierz menu i grupę, do której chcesz wysłać ten przepis",
    "cookbook.Selecione o modelo do equipamento primeiro": "Najpierw wybierz model sprzętu",
    "cookbook.Grupo": "Grupa",
    "cookbook.Não foi possível salvar os passos da receita": "Nie udało się zapisać kroków przepisu",
    "cookbook.Bovina": "Wołowina",
    "cookbook.Frango": "Kurczak",
    "cookbook.Ovos": "Jajka",
    "cookbook.Pães": "Chleby",
    "cookbook.Peixes": "Ryba",
    "cookbook.Queijo": "Ser",
    "cookbook.Suína": "Wieprzowina",
    "cookbook.Vegetais": "Warzywa",
    "cookbook.Outros": "Inne",
    "cookbook.Entradas/aperitivos": "Przystawki",
    "cookbook.Principais": "Dania główne",
    "cookbook.Snacks": "Przekąski",
    "cookbook.Pizzas": "Pizze",
    "cookbook.Massas": "Makarony",
    "cookbook.Acompanhamentos": "Dodatek",
    "cookbook.Sobremesas": "Desery",
    "cookbook.Manhã": "Śniadania",
    "cookbook.Padaria": "Piekarnia",
    "cookbook.Todos": "Wszystko",
    "cookbook.Não atribuir origem": "Nie przypisuj pochodzenia",
    "cookbook.Brasil": "Brazylia",
    "cookbook.Alemanha": "Niemcy",
    "cookbook.França": "Francja",
    "cookbook.Rússia": "Rosja",
    "cookbook.China": "Chiny",
    "cookbook.Japão": "Japonia",
    "cookbook.Itália": "Włochy",
    "cookbook.Egito": "Egipt",
    "cookbook.Grécia": "Grecja",
    "cookbook.Argentina": "Argentyna",
    "cookbook.África": "Afryka",
    "cookbook.Estados Unidos": "Stany Zjednoczone",
    "cookbook.Coreia": "Korea",
    "cookbook.Turquia": "Turcja",
    "cookbook.Ideal para": "Idealne do",
    "cookbook.Polônia": "Polska",
    "cookbook.Sanduíches": "Kanapki",
    "cookbook.A receita não foi adicionada ao menu pois não há grupos criados":
    "Przepis nie został dodany do menu, ponieważ nie utworzono żadnych grup.",
    "cookbook.Nova Receita": "Nowy przepis",
    
    //EQUIPAMENTOS
    "equipment.equipamentos": "Sprzęt",
    "equipment.procurar equipamento": "Wyszukaj sprzęt lub użytkownika",
    "equipment.adicionar equipamento": "Dodaj sprzęt",
    "equipment.atualizar equipamento": "Aktualizuj sprzęt",
    "equipment.+ equipamentos": "Sprzęt",
    "equipment.buscar equipamento": "Wyszukaj sprzęt",
    "equipment.Desvincular": "Odłącz",
    "equipment.Editar": "Edytuj",
    "equipment.sem conteúdo": "NADAL NIE MA TU ŻADNYCH URZĄDZEŃ :(",
    "equipment.description.sem conteúdo": "Kliknij przycisk „Dodaj urządzenie” znajdujący się w prawym górnym rogu i połącz swoje piece.",
    "equipment.editar equipamento": "edytuj sprzęt",
    "equipment.equipamento editado com sucesso!": "Sprzęt pomyślnie edytowany!",
    "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "Nie udało się edytować sprzętu. Spróbuj ponownie później",
    "equipment.Menu exportado com sucesso!": "Menu wyeksportowane pomyślnie!",
    "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "Nie udało się wyeksportować menu. Spróbuj ponownie później",
    "equipment.Selecione pelo menos um equipamento para enviar o menu": "Wybierz co najmniej jeden sprzęt do wysłania menu",
    "equipment.Informações do menu": "Informacje o menu",
    "equipment.Procurar receita ou grupo": "Wyszukaj przepis lub grupę",
    "equipment.Grupo": "Grupa",
    "equipment.Grupos de equipamentos": "Grupy wyposażenia",
    "equipment.Receita": "Przepis",
    "equipment.Quantidade": "Ilość",
    "equipment.Receitas mais preparadas no equipamento durante o período": "Najczęściej przygotowane przepisy na urządzeniu w okresie",
    "equipment.Informações de limpeza": "Informacje o czyszczeniu",
    "equipment.Data da limpeza": "Data czyszczenia",
    "equipment.Hora da limpeza": "Godzina czyszczenia",
    "equipment.nome": "Nazwa",
    "equipment.modelo": "Model",
    "equipment.categoria": "Kategoria",
    "equipment.loja": "Sklep",
    "equipment.desvincular equipamento": "Odłącz sprzęt",
    "equipment.unlink.paragrafo 1": "Czy chcesz odłączyć sprzęt od platformy IOK?",
    "equipment.unlink.paragrafo 2": "W ten sposób nie będzie możliwe zarządzanie ustawieniami i menu poprzez platformę, chyba że ponownie połączysz sprzęt, postępując zgodnie z instrukcjami łączenia.",
    "equipamento desvinculado com sucesso!": "Sprzęt odłączony pomyślnie!",
    "equipment.ocorreu um erro. Tente novamente mais tarde": "Wystąpił błąd. Spróbuj ponownie później",
    "equipment.sim": "Tak",
    "equipment.não": "Nie",
    "equipment.Encerrar acesso remoto": "Zakończ zdalny dostęp",
    "equipment.Horas sem limpeza": "Godziny bez czyszczenia",
    "equipment.Histórico de eventos": "Historia zdarzeń",
    "equipment.Histórico de eventos do forno": "Historia zdarzeń pieca",
    "equipment.Histórico de eventos da fermentadora": "Historia zdarzeń fermentatora",
    "equipment.Receitas executadas": "Wykonane przepisy",
    "equipment.Hoje": "Dzisiaj",
    "equipment.Tempo de porta aberta": "Czas otwarcia drzwi",
    "equipment.Tempo médio aproximado": "Średni przybliżony czas",
    "equipment.Filtrar eventos": "Filtruj zdarzenia",
    "equipment.Evento": "Zdarzenie",
    "equipment.Data": "Data",
    "equipment.ERRO SENSOR RI": "Błąd z czujnikiem dolnej rezystancji",
    "equipment.ERRO COM INV. DE FREQ.": "Błąd z falownikiem częstotliwości",
    "equipment.ERRO MAGNETRON": "Błąd magnetrnou",
    "equipment.ERRO SENSOR CAMARA": "Błąd z czujnikiem kamery",
    "equipment.ERRO CAN": "Błąd CAN",
    "equipment.Erro INVERSOR DE FREQUENCIA": "Błąd falownika częstotliwości",
    "equipment.ERRO DO MODELO DO EQUIPAMENTO": "Błąd modelu sprzętu",
    "equipment.ERRO PAINEL": "Błąd panelu",
    "equipment.ERRO INV.FREQ.STATUS": "Status błędu falownika częstotliwości",
    "equipment.ERRO SENSOR BOARD": "Błąd czujnika płyty",
    "equipment.ERRO ENERGY": "Błąd energii",
    "equipment.ERRO I2C": "Błąd I2C",
    "equipment.EQUIPAMENTO LIGADO": "Sprzęt włączony",
    "equipment.EQUIPAMENTO DESLIGADO": "Sprzęt wyłączony",
    "equipment.Plataforma": "Platforma",
    "equipment.Forno": "Piekarnik",
    "equipment.Origem": "Pochodzenie",
    "equipment.Locais": "Lokalizacje",
    "equipment.não foi possível carregar as entidades": "Nie udało się załadować jednostek",
    "equipment.conceder acesso remoto a": "Przyznaj zdalny dostęp do",
    "equipment.atualizar software": "zaktualizować oprogramowanie",
    "equipment.suporte": "Wsparcie",
    "equipment.PIN": "PIN",
    "equipment.nome do equipamento": "Nazwa sprzętu",
    "equipment.vinculado à loja": "Powiązane ze sklepem",
    "equipment.cadastrar loja": "Zarejestruj sklep",
    "equipment.informe o PIN do forno": "Podaj PIN do piekarnika",
    "equipment.preencha o PIN do forno": "Wypełnij pole PIN piekarnika",
    "equipment.adicione um nome para facilitar seu reconhecimento": "Dodaj nazwę, aby ułatwić rozpoznawanie",
    "equipment.preencha o nome do equipamento": "Wypełnij nazwę sprzętu",
    "equipment.selecionar": "Wybierz",
    "equipment.nome fantasia": "Nazwa fantazyjna",
    "equipment.informe o nome fantasia": "Podaj nazwę fantazyjną",
    "equipment.preencha o nome fantasia": "Wypełnij nazwę fantazyjną",
    "equipment.CNPJ": "CNPJ",
    "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XXX/0001.XX",
    "equipment.preencha o CNPJ": "Wypełnij numer CNPJ",
    "equipment.CEP": "Kod pocztowy",
    "equipment.00000-000": "00000-000",
    "equipment.preencha o CEP": "Wypełnij kod pocztowy",
    "equipment.cidade": "Miasto",
    "equipment.informe a cidade": "Podaj miasto",
    "equipment.preencha a cidade": "Wypełnij miasto",
    "equipment.UF": "Stan",
    "equipment.bairro": "Dzielnica",
    "equipment.informe o bairro": "Podaj dzielnicę",
    "equipment.endereço": "Adres",
    "equipment.informe o seu endereço": "Podaj swój adres",
    "equipment.preencha o seu endereço": "Wypełnij swoje adres",
    "equipment.Nº": "Numer",
    "equipment.equipamento cadastrado com sucesso!": "Sprzęt zarejestrowany pomyślnie!",
    "equipment.ocorreu um erro": "Wystąpił błąd",
    "equipment.preencha o modelo": "Wypełnij model",
    "equipment.selecione uma categoria": "Wybierz kategorię",
    "equipment.selecione uma loja": "Wybierz sklep",
    "equipment.preencha o bairro": "Wypełnij dzielnicę",
    "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde": "Nie udało się zarejestrować sprzętu. Spróbuj ponownie później",
    "equipment.loja cadastrada com sucesso": "Sklep zarejestrowany pomyślnie",
    "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde": "Nie udało się zarejestrować sklepu. Spróbuj ponownie później",
    "equipment.equipment": "sprzęt",
    "equipment.stores": "sklepy",
    "equipment.search equipment": "szukaj sprzętu",
    "equipment.add equipment": "dodaj sprzęt",
    "equipment.update equipment": "aktualizuj sprzęt",
    "equipment.plus equipment": "sprzęt",
    "equipment.Procurar equipamento": "Szukaj sprzętu",
    "equipment.EQUIPAMENTOS": "SPRZĘT",
    "equipment.Atualizar equipamento": "Aktualizuj sprzęt",
    "equipment.Atualizar equipamentos": "Aktualizuj sprzęt",
    "equipment.confirmar": "potwierdź",
    "equipment.Selecione os modelos que deseja atualizar:": "Wybierz modele, które chcesz zaktualizować",
    "equipment.Como deseja realizar a atualização?": "Jak chcesz postępować z aktualizacją?",
    "equipment.Enviar atualização pela plataforma (internet)": "Wyślij aktualizację przez platformę (internet)",
    "equipment.Salvar arquivo de atualização no dispositivo": "Zapisz plik aktualizacji na urządzeniu",
    "equipment.Linha Express": "Linia Express",
    "equipment.Escolha como deseja realizar a atualização": "Wybierz, jak chcesz postępować z aktualizacją",
    "equipment.Selecione ao menos um modelo de equipamento para atualizar": "Wybierz co najmniej jeden model sprzętu do zaktualizowania",
    "equipment.Status:": "Status: ",
    "equipment.Número de série:": "Numer seryjny",
    "equipment.Menu:": "Menu",
    "equipment.Menu": "Menu",
    "equipment.Loja:": "Sklep",
    "equipment.End:": "Adres: ",
    "equipment.Endereço:": "Adres: ",
    "equipment.Cidade:": "Miasto: ",
    "equipment.CEP:": "Kod pocztowy: ",
    "equipment.Atualização de software enviada com sucesso!": "Aktualizacja oprogramowania wysłana pomyślnie!",
    "equipment.Não foi possível enviar a atualização de sodtware. Tente novamente mais tarde": "Nie udało się wysłać aktualizacji oprogramowania. Spróbuj ponownie później",
    "equipment.Download realizado com sucesso": "Pobieranie zakończone pomyślnie",
    "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "Nie udało się ukończyć pobierania. Spróbuj ponownie później",
    "equipment.name": "Nazwa",
    "equipment.model": "Model",
    "equipment.category": "Kategoria",
    "equipment.store": "sklep",
    "FIT Express/FIT ST": "FIT Express/FIT ST",
    "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
    "Forza STi": "Forza STi",
    "TSi": "TSi",
    "FIT Express": "FIT Express",
    "FIT ST": "FIT ST",
    "equipment.Preencha o nome da versão": "Podaj nazwę wersji",
    "equipment.Informe aqui todas as alterações desta nova versão": "Wprowadź wszystkie zmiany w tej nowej wersji",
    "equipment.Nova versão de software atualizada com sucesso!": "Nowa wersja oprogramowania zaktualizowana pomyślnie!",
    "equipment.Informe pelo menos uma mudança nesta versão": "Wprowadź co najmniej jedną zmianę w tej wersji",
    "equipment.Falha ao ler o arquivo": "Nie udało się odczytać pliku",
    "equipment.selecionar tipo": "wybierz typ",
    "equipment.selecione o tipo da versão": "wybierz typ wersji",
    "equipment.atualização": "AKTUALIZACJA",
    "equipment.Selecione abaixo o que deseja fazer:": "Wybierz poniżej, co chcesz zrobić:",
    "equipment.Atualizar meus equipamentos": "Zaktualizuj mój sprzęt",
    "equipment.Enviar atualização para usuários selecionados": "Wyślij aktualizację do wybranych użytkowników",
    "equipment.ENVIAR": "WYŚLIJ",
    "equipment.ENVIAR ATUALIZAÇÃO": "WYŚLIJ AKTUALIZACJĘ",
    "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "Wybierz adresy e-mail, do których chcesz wysłać aktualizację:",
    "equipment.A atualização disponibilizada no dia": "Dostępna aktualizacja w dniu",
    "equipment.referente ao equipamento": "dotyczące sprzętu",
    "equipment.contempla o seguinte:": "rozważ następujące:",
    "equipment.Selecionar arquivo para envio": "Wybierz plik do wysłania",
    "equipment.Por favor, selecione um arquivo .tar": "Proszę wybrać plik .tar",
    "equipment.Selecione o modelo do equipamento:": "Wybierz model sprzętu:",
    "equipment.Selecione uma opção": "Wybierz opcję",
    "equipment.Nomeie a versão": "Nadaj nazwę wersji",
    "equipment.Clique sobre o arquivo que deseja baixar:": "Kliknij plik, który chcesz pobrać:",
    "equipment.Baixar atualização": "Pobierz aktualizację",
    "equipment.Versões": "Wersje",
    "equipment.e superiores": "i wyżej",
    "FIT Express, FIT ST": "FIT Express, FIT ST",
    "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
    "equipment.e": "i",
    "equipment.Últimas versões de software:": "Najnowsze wersje oprogramowania: ",
    "equipment.Você não possui nenhum equipamento desatualizado": "Nie masz przestarzałego sprzętu",
    "equipment.grupos": "grupy",
    "equipment.não foi possível carregar os grupos de equipamentos da companhia": "Nie można załadować grup sprzętu firmy",
    "equipment.vinculado ao grupo": "Połączony z grupą",
    "equipment.selecione um grupo": "Wybierz grupę",
    "equipment.cadastrar grupo": "Zarejestruj grupę",
    "equipment.Número de Série": "Numer seryjny",
    "equipment.Número de série": "Numer seryjny",
    "equipment.Versão": "Wersja",
    "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "Nie udało się zarejestrować sprzętu. Wybierz lub zarejestruj grupę",
    "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "TWÓRZ GRUPY SPRZĘTU!",
    "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "Aby użytkownicy powiązani z kontem mogli widzieć sprzęt, musisz:",
    "equipment.1) Criar grupo(s);": "1) Tworzyć grupy;",
    "equipment.2) Atribuir equipamento(s) ao grupo;": "2) Przypisywać sprzęt do grupy;",
    "equipment.3) Atribuir usuário(s) ao grupo.": "3) Przypisywać użytkowników do grupy.",
    "equipment.Status software": "Status oprogramowania",
    "equipment.Status menu": "Status menu",
    "equipment.Pendente": "Oczekujący",
    "equipment.Aceito": "Zaakceptowany",
    "equipment.Recusado": "Odrzucony",
    "equipment.Atualizar software": "Zaktualizuj oprogramowanie",
    "equipment.Deseja enviar a atualização para o equipamento selecionado?": "Czy chcesz wysłać aktualizację do wybranej jednostki?",
    "equipment.Companhia": "Firma",
    "equipment.Exportar menu": "Eksportuj menu",
    "equipment.companhias": "firmy",
    "equipment.Nome da companhia": "Nazwa firmy",
    "equipment.Procurar equipamento, usuário ou companhia": "Wyszukaj sprzęt, użytkownika lub firmę",
    "equipment.Versão da power": "Wersja mocy",
    "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "NIE MA JESZCZE DANYCH PRZEPISU :(",
    "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "NIE MA TUTAJ DANYCH DO CZYSZCZENIA :(",
    "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "NIE MA TUTAJ DANYCH O WYDARZENIU :(",
    "ID": "ID",
    "equipment.Hora": "Godzina",
    "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "NAJCZĘŚCIEJ WYSTĘPUJĄCE ZDARZENIA NA SPRZĘCIE W OKRESIE",
    "equipment.hour": "G",
    "equipment.minutes": "Min",
    "equipment.date format": "DD/MM/RRRR",
    "equipment.preparada": "przygotowana",
    "equipment.vezes": "razy",
    "equipment.vez": "raz",
    "equipment.Ver": "Zobacz",
    "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "Dane są przechowywane na platformie przez czas niezbędny do zapewnienia wsparcia, konserwacji i rozwoju produktów.",
    "equipment.Ligado": "Włączony",
    "equipment.Desligado": "Wyłączony",
    "equipment.CAN ERROR": "Błąd CAN",
    "equipment.CAMERA SENSOR ERROR": "Błąd czujnika komory",
    "equipment.STEAM/RI SENSOR ERROR": "Błąd czujnika RI",
    "equipment.PROBE 1 ERROR": "Alarm sondy 1",
    "equipment.PROBE 2 ERROR": "Alarm sondy 2",
    "equipment.PROBE 3 ERROR": "Alarm sondy 3",
    "equipment.PROBE 4 ERROR": "Alarm sondy 4",
    "equipment.PROBE 5 ERROR": "Alarm sondy 5",
    "equipment.PROBE 6 ERROR": "Alarm sondy 6",
    "equipment.GENERAL PROBE ERROR": "Ogólny błąd sondy",
    "equipment.WATER LACK ERROR": "Alarm braku wody",
    "equipment.HIGH TEMPERATURE PANEL ERROR": "Alarm wysokiej temperatury na desce rozdzielczej",
    "equipment.FREQUENCY INVERTER GENERAL ERROR": "Błąd przetwornicy częstotliwości",
    "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "Alarm komunikacji w przetwornicy częstotliwości",
    "equipment.FREQUENCY INVERTER STATUS ERROR": "Alarm stanu przetwornicy częstotliwości",
    "equipment.CLEANING NOT COMPLETED ERROR": "Alarm niekompletnego czyszczenia",
    "equipment.MAGNETRON ERROR": "Alarm magnetronu",
    "equipment.EQUIPMENT FAMILY/MODEL ERROR": "Błąd modelu urządzenia",
    "equipment.BOARD TEMPERATURE SENSOR ERROR": "Alarm czujnika temperatury płyty",
    "equipment.ENERGY MODULE ERROR": "Błąd modułu energetycznego",
    "equipment.POWER BOARD I2C BUS ERROR": "Błąd płyty zasilającej",
    "equipment.GAS SYSTEM ERROR": "Błąd gazu",
    "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "Błąd bardzo wysokiej temperatury panelu",
    "equipment.POWER ON": "Włączony",
    "equipment.POWER OFF": "Wyłączony",
    "equipment.DOOR OPENED": "Drzwi otwarte",
    "equipment.DOOR CLOSED": "Drzwi zamknięte",
    "equipment.CLEANING CANCELED ERROR": "Odkażanie anulowane przez użytkownika",
    "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "Nie znaleziono kodu PIN. Sprawdź i spróbuj ponownie",
    "equipment.Ultracongeladores": "Schładzarki szokowe",
    "equipment.PIN já vinculado a outra conta": "Kod PIN jest już powiązany z innym kontem",
    "equipment.Equipamento já cadastrado nesta conta": "Urządzenie jest już zarejestrowane na tym koncie",
    "equipment.Não foi possível validar o PIN. Tente novamente": "Nie udało się zweryfikować kodu PIN. Spróbuj ponownie",
    "equipment.Modelo definido pelo equipamento": "Określony przez urządzenie",
    "equipment.Número de série offline inválido": "Wprowadź siedem cyfr bez spacji i zera na początku",
    "equipment.Número de série já cadastrado": "Numer seryjny jest już zarejestrowany",
    "equipment.Online": "Włączony",
    "equipment.Offline": "Wyłączony",
    "equipment.Exibir apenas eventos": "Pokaż tylko wydarzenia",
    "equipment.Endereço": "Adres",
    "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "Sprzęt podłączony do platformy",
    "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "Sprzęt odłączony od platformy",
    "equipment.MENU RECEIVED FROM THE PLATFORM": "Menu z platformy zaakceptowane przez użytkownika",
    "equipment.MENU REJECTED BY THE USER": "Menu z platformy odrzucone przez użytkownika",
    "equipment.CONNECTED TO THE INTERNET": "Podłączony do internetu",
    "equipment.DISCONNECTED FROM THE INTERNET": "Odłączono od Internetu",
    "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "Niestety nie ma wersji kompatybilnych z tym sprzętem, które potrafią przesyłać dane.",
    "equipment.O equipamento": "Urządzenie",
    "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "musi zostać zaktualizowane do najnowszej wersji oprogramowania, aby zaczęło przesyłać dane na platformę",
    "equipment.Versão do seu equipamento": "Wersja twojego urządzenia",
    "equipment.Versão disponível": "Dostępna wersja",
    "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "Wybierz poniżej, jak chcesz wysłać aktualizację do swojego urządzenia",
    "equipment.Salvar no dispositivo": "Zapisz na urządzeniu",
    "equipment.Enviar pela internet": "Wyślij przez Internet",
    "equipment.Cliente": "Klient",
    "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "NIE ZNALEZIONO NUMERU SERYJNEGO",
    "equipment.BUSCAR": "SZUKAJ",
    "equipment.ACESSADOS RECENTEMENTE": "OSTATNI DOSTĘP",
    "equipment.SEM BUSCAS RECENTES": "BRAK OSTATNICH WYSZUKIWAŃ",
    "equipment.description.SEM BUSCAS RECENTES": "Użyj numeru seryjnego, aby wyszukać sprzęt.",
    "equipment.Procurar equipamento pelo número de série": "Wyszukaj sprzęt po numerze seryjnym",
    "equipment.AIR FILTER CLEANING COMPLETED": "Czyszczenie filtra powietrza zakończone",
    "equipment.AIR FILTER CLEANING REJECTED": "Odmowa czyszczenia filtra powietrza",
    "equipment.CATALYTIC FILTER CLEANING COMPLETED": "Zakończono czyszczenie filtra katalitycznego",
    "equipment.CATALYTIC FILTER CLEANING REJECTED": "Odrzucono czyszczenie filtra katalitycznego",
    "equipment.ID do equipamento": "ID urządzenia",
    "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "Cały sprzęt musi być połączony z grupą. Wybierz grupę z listy lub zarejestruj nową klikając + Zarejestruj grupę.",
    "equipment.Nomeie seu forno": "Nazwij swój piekarnik",
    "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "Aby zobaczyć PIN, należy wejść do Wirtualnej Platformy IOK w ustawieniach sprzętu.",
    "equipment.localização": "Lokalizacja",
    "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "NIE MA JESZCZE ZAREJESTROWANEJ LOKALIZACJI :(",
    "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "Kliknij przycisk znajdujący się w prawym górnym rogu i dodaj lokalizacje.",
    "equipment.Procurar empresa ou local": "Wyszukaj firmę lub lokalizację",
    "equipment.Adicionar localização": "Dodaj miejsce",
    "equipment.Adicionar": "Dodaj",
    "equipment.espaço": "Przestrzeń",
    "equipment.local": "Lokalny",
    "equipment.EXCLUIR LOCALIZAÇÃO": "USUŃ LOKALIZACJĘ",
    "equipment.Você deseja excluir esta localização?": "Czy chcesz usunąć tę lokalizację?",
    "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "Gdy to zrobisz, powiązane z nim urządzenia nie będą wyświetlać żadnej lokalizacji, co spowoduje konieczność zapewnienia dla nich nowej lokalizacji.",
    "equipment.Localização deletada com sucesso!": "Lokalizacja została pomyślnie usunięta!",
    "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "Błąd podczas usuwania lokalizacji. Spróbuj ponownie później",
    "equipment.Não foi possivel deletar a localização": "Nie można usunąć lokalizacji",
    "equipment.Localização adicionada com sucesso!": "Lokalizacja została dodana pomyślnie!",
    "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "Nie można dodać lokalizacji. Spróbuj ponownie później",
    "equipment.Nome do espaço": "Nazwa kosmiczna",
    "equipment.Informe o nome do espaço": "Wpisz nazwę przestrzeni",
    "equipment.Preencha o nome do espaço": "Wpisz nazwę przestrzeni",
    "equipment.país": "Kraj",
    "equipment.Endereço (rua, avenida, rodovia)": "Adres (ulica, aleja, autostrada)",
    "equipment.Nº/Km": "Nr/Km",
    "equipment.informe o país": "Wprowadź kraj",
    "equipment.preencha o país": "Wpisz kraj",
    "equipment.Localização editada com sucesso!": "Lokalizacja została edytowana pomyślnie!",
    "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "Nie można edytować lokalizacji. Spróbuj ponownie później",
    "equipment.Editar localização": "Edytuj lokalizację",
    "equipment.Pico de preparações": "Szczyt przygotowań",
    "equipment.informações da semana": "informacja tygodnia",
    "equipment.horários de pico": "godziny szczytu",
    "equipment.horário de pico": "czas szczytu",
    "equipment.preparações do dia": "przygotowania dnia",
    "equipment.Horário": "Czas",
   "equipment.Preparações": "Przygotowania",
    "equipment.recipeTable.recipe": "Przepis",
    "equipment.recipeTable.origin": "Źr.",
    "equipment.recipeTable.executions": "Wyk.",
    "equipment.recipeTable.lastExecution": "Ostatnie wykonanie",
    "equipment.dia selecionado": "wybrany dzień",
    "equipment.Vinculação IOK": "Wiązanie IOK",
    "equipment.Última preparação": "Ostatnie przygotowanie",
    "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "Prawidłowe i codzienne czyszczenie piekarnika pomaga w jego prawidłowym funkcjonowaniu i ma wpływ na gwarancję.",
    "equipment.Total de limpezas realizadas:": "Całkowite czyszczenie:",
    "equipment.Limpezas não concluídas:": "Czyszczenie nie zostało zakończone:",
    "equipment.Desde a vinculação do forno a IOK": "Od podłączenia piekarnika do IOK",
    "equipment.Equipamento ligado há:": " Sprzęt włączony od:",
    "equipment.Total de receitas preparadas:": "Łączna liczba przygotowanych przepisów:",
    "equipment.Receitas preparadas": "Przygotowane przepisy",
    "equipment.Aberturas de porta": "Otwory drzwiowe",
    "equipment.Desde a última vez que o forno foi ligado": "Od ostatniego włączenia piekarnika",
    "equipment.Preparação": "Przygotowanie",
    "equipment.Nenhuma localização criada": "Nie utworzono żadnych lokalizacji",
    "equipment.Acesso remoto": "Zdalny dostęp",
    "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "Wprowadź identyfikator firmy, która może uzyskać zdalny dostęp do Twojego piekarnika. Używać ; do oddzielenia identyfikatorów.",
    "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "Zdalny dostęp umożliwia wybranym firmom wysyłanie menu i aktualizacji do Twojego sprzętu.",
    "equipment.Concedo acesso remoto à Prática oficial.": "Udzielam zdalnego dostępu do oficjalnej Prática.",
    "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "Czy chcesz wybrać inne urządzenia powiązane z Twoim kontem i przyznać im zdalny dostęp?",
    "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "Wybierz poniżej sprzęt, do którego chcesz przyznać zdalny dostęp",
    "equipment.Acesso remoto concedido com sucesso!": "Zdalny dostęp został przyznany pomyślnie!",
    "equipment.Selecione pelo menos um equipamento": "Wybierz co najmniej jedno urządzenie",
    "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "Nie można edytować wyposażenia. Spróbuj ponownie później",
    "equipment.Solicitar atendimento": "Zapytaj o usługę",
    "equipment.Relate um problema": "Zgłoś problem",
    "equipment.Descreva aqui o problema de seu equipamento": "Opisz tutaj swój problem ze sprzętem",
    "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "Nie mogliśmy wysłać Twojego zgłoszenia serwisowego. Spróbuj później",
    "equipment.Solicitação técnica enviada com sucesso!": "Zapytanie techniczne zostało wysłane pomyślnie!",
    "equipment.Enviar": "Potwierdzać",
    "equipment.Solicitação de atendimento": "Zapytanie serwisowe",
    "equipment.Informações do magnetron": "Informacje o magnetronie",
    "equipment.Vida útil aproximada": "Szacowana żywotność",
    "equipment.MAGNETRON USAGE HOURS": "Godziny pracy magnetronu",
    "equipment.Atendimento": "Praca",
    "equipment.Eventos mais ocorridos no equipamento durante o período": "Zdarzenia najczęściej występujące na sprzęcie w danym okresie",
    "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "SPRZĘT BEZ NUMERU SERYJNEGO",
    "equipment.Filtros": "Filtry",
    "equipment.Filtrar": "Filtrować",
    "equipment.Limpar filtros": "Wyczyść filtry",
    "equipment.Procurar por modelo, versão ou país": "Wyszukaj według modelu, wersji lub kraju",
    "equipment.Procurar equipamento, NS, modelo, versão ou país": "Wyszukaj urządzenie, NS, model, wersję lub kraj",
    "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "Następujące ID nie należą do firmy typu 'Dystrybutor' i zostały usunięte",
    "equipment.BAIXAR VERSÕES": "POBIERZ WERSJE",
    "equipment.Compatível com todas as versões da IHM.": "Kompatybilny ze wszystkimi wersjami HMI.",
    "equipment.Compatível apenas com a versão 2.0.0C da Power.": "Kompatybilny tylko z wersją Power 2.0.0C.",
    "equipment.Procurar evento": "Szukaj wydarzenia",
    "equipment.Forno conectado": "Piekarnik połączony",
    "equipment.Limpeza de filtro de ar": "Czyszczenie filtra powietrza",
    "equipment.Limpeza de filtro catalítico": "Czyszczenie filtra katalitycznego",
    "equipment.Forno ligado": "Piekarnik włączony",
    "equipment.Inversor de frequência": "Przetwornica częstotliwości",
    "equipment.Temperatura de painel": "Temperatura panelu",
    "equipment.Sensor da câmara": "Czujnik komory",
    "equipment.Magnetron": "Magnetron",
    "equipment.Power": "Power",
    "equipment.Informações de menu": "Informacje o menu",
    "equipment.Limpeza": "Czyszczenie",
    "equipment.Limpeza realizada": "Wykonane czyszczenie",
    "equipment.Limpeza recomendada": "Zalecane czyszczenie",
    "equipment.O equipamento já está utilizando a versão mais recente do software.": "Sprzęt już używa najnowszej wersji oprogramowania.",
    "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "Uwaga: w obliczeniach żywotności magnetronu nie uwzględnia się czasu użytkowania wcześniejszego niż wersja F1.1.0.",
    "equipment.Equipamentos com erro": "Urządzenia z błędami",
    "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.":
    "Wkrótce będziesz mieć dostęp do ważnych danych przesyłanych przez piekarnik, takich jak godziny szczytu, najczęściej wykonywane przepisy, historia czyszczenia, zdarzenia, które miały miejsce i wiele więcej! Pamiętaj, aby Twój sprzęt był zawsze aktualny o nowe wersje dostępne na platformie.",
    "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.":
    "Aby czyszczenie zostało zarejestrowane na urządzeniu i przesłane na platformę, konieczne jest wykonanie pełnej procedury krok po kroku w piekarniku. Oglądanie filmów przedstawiających poszczególne kroki nie jest obowiązkowe, jeśli są dostępne.",
    "equipment.Horas de uso": "Godziny pracy",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "Zliczanie godzin pracy magnetronu jest wykonywane od wersji F1.0.6",
    "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.": "Aktualizacja oprogramowania trwa około 15 minut. W trakcie procesu piekarnik uruchomi się ponownie i wyświetli niebieski ekran do momentu zakończenia. Aby uniknąć błędów, pozostaw urządzenie włączone i podłączone do internetu. Jeśli zdecydujesz się na aktualizację za pomocą pendrive'a, nie usuwaj go do zakończenia procesu.",
    'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "Urządzenie {name} z oprogramowaniem {version} musi być aktualizowane przez USB. Aktualizacja oprogramowania trwa około 15 minut. W trakcie procesu piekarnik uruchomi się ponownie i wyświetli niebieski ekran do momentu zakończenia. Aby uniknąć błędów, pozostaw urządzenie włączone i podłączone do internetu. Jeśli zdecydujesz się na aktualizację za pomocą pendrive'a, nie usuwaj go do zakończenia procesu.",
    "equipment.Observação": "Uwaga:",
    "equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.": "W przypadku wersji ST2.0.0 i nowszych wysyłanie aktualizacji za pośrednictwem platformy (Wi-Fi) będzie nadal dostępne.",
    "equipment.Aqui você encontra informações gerais sobre o equipamento;": "Tutaj znajdziesz ogólne informacje o sprzęcie;",
    "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "Klikając na te przyciski, możesz poprosić o pomoc techniczną dotyczącą Twojego piekarnika i wyeksportować jego dane do arkuszy kalkulacyjnych Excel;",
    "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "W poniższych panelach znajdziesz szczegółowe informacje na temat przygotowania przepisów;",
    "equipment.Horário de pico;": "Godziny szczytu;",
    "equipment.Informações referentes a higienização;": "Informacje dotyczące czyszczenia;",
    "equipment.E histórico de eventos;": "I historia wydarzeń;",
    "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "Pamiętaj, że musisz wybrać okres, dla którego chcesz wyświetlić dane. Możesz to zrobić, klikając kalendarz w panelach i wybierając filtry.",
    "equipment.Baixando o arquivo... Ele estará disponível em breve!": "Pobieranie pliku... Wkrótce będzie dostępny!",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "Zliczanie godzin pracy magnetronu jest wykonywane od wersji F1.1.0",
    "equipment.Data de fabricação": "Data produkcji",
    "equipment.manutenção": "konserwacja",
    "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.":
    "Podczas wyszukiwania i znalezienia numeru seryjnego otwarty zostanie tymczasowy kanał bezpośrednio z piecem, umożliwiający udostępnianie jego danych dotyczących konserwacji. Te dane nie będą przechowywane na platformie, co wymaga ponownego wyszukiwania za każdym razem, gdy jest to pożądane.",
    "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "WPROWADŹ NUMER SERYJNY I KLIKNIJ SZUKAJ",
    "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.": "Dane konserwacyjne będą wysyłane wyłącznie w modelach FIT Express / FIT Single Mag / FIT XL z wersją oprogramowania F2.1.0. Wersja ta będzie uwzględniać informacje, zwłaszcza pochodzące od księgowych.",
    "equipment.Procurar número de série": "Wyszukaj numer seryjny",
    "equipment.Alerta": "Alarm",
    "equipment.Local": "Lokalizacja",
    "equipment.Software": "Oprogramowanie",
    "equipment.Forno sem limpeza há": "Piekarnik bez czyszczenia od",
    "equipment.Horário de pico": "Godziny szczytu",
    "equipment.HP": "GS",
    "equipment.RECIPE STARTED": "Przepis rozpoczęty",
    "equipment.RECIPE CANCELED": "Przepis anulowany przez użytkownika",
    "equipment.RECIPE COMPLETED": "Przepis zakończony pomyślnie",
    "equipment.DOOR OPENED RECIPE": "Drzwi otwarte podczas przepisu",
    "equipment.DOOR CLOSED RECIPE": "Drzwi zamknięte podczas przepisu",
    "equipment.Receitas iniciadas": "Rozpoczęte przepisy",
    "equipment.Receitas concluídas": "Zakończone przepisy",
    "equipment.Receitas interrompidas": "Przerwane przepisy",
    "equipment.Total de receitas concluídas:": "Łączna liczba zakończonych przepisów:",
    "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "ŁĄCZNA LICZBA PRZERWANYCH PRZEPISÓW",
    "equipment.DOWNLOAD_PROGRESS": "POBIERANIE PLIKU... PROSZĘ CZEKAĆ, POSTĘP: {progress}%",
    "equipment.Informe o número de série do forno": "Wprowadź numer seryjny pieca",
    "equipment.preencha o número de série do forno": "Uzupełnij numer seryjny pieca",
    "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "NUMER SERYJNY NIE ZAREJESTROWANY",
    "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "Nie znaleziono numeru seryjnego. Sprawdź i spróbuj ponownie",
    "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "Przed rozpoczęciem aktualizacji wykonaj kopię zapasową przepisów zapisanych na urządzeniu, aby zapewnić integralność danych. Kopię zapasową można wykonać za pomocą pendrive’a lub przez platformę. Umożliwia to odzyskanie informacji w przypadku ich utraty.",
    "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "Menu otrzymane z platformy poprzez wymuszoną aktualizację",
    "equipment.Nome da receita não encontrado": "Nie znaleziono nazwy przepisu",
    "equipment.passos": "{count, plural, one {krok} few {kroki} many {kroków} other {kroku}}",
    "equipment.minAbbreviation": "min",
    "equipment.secAbbreviation": "sek",
    "equipment.status online": "status online",
    "equipment.status offline": "status offline",
    "equipment.software accepted": "oprogramowanie zaakceptowane",
    "equipment.menu accepted": "menu zaakceptowane",
    "equipment.software pending": "oprogramowanie oczekujące",
    "equipment.menu pending": "menu oczekujące",
    "equipment.software refused": "oprogramowanie odrzucone",
    "equipment.menu refused": "menu odrzucone",
    "equipment.ENCERRAR SESSÃO": "WYLOGUJ SIĘ",
    "equipment.Configurações": "Ustawienia",
    "equipment.Tempo de preaquecimento": "Czas nagrzewania",
    "equipment.Formato de data": "Format daty",
    "equipment.Formato de hora": "Format godziny",
    "equipment.Unidade de temperatura": "Jednostka temperatury",
    "equipment.Aquecer/dourar mais": "Podgrzej/przyrumień bardziej",
    "equipment.Fabricante": "Producent",
    "equipment.Voltagem": "Napięcie",
    "equipment.Introdução": "Wprowadzenie",
    "equipment.Modelo": "Model",
    "equipment.Motor": "Silnik",
    "equipment.Hostname": "Hostname",
    "equipment.STATUS DA OPERAÇÃO": "STATUS OPERACJI",
    "equipment.ÚLTIMA LIMPEZA": "OSTATNIE CZYSZCZENIE",
    "equipment.VELOCIDADE DO MOTOR": "PRĘDKOŚĆ SILNIKA",
    "equipment.TENSÃO ATUAL": "AKTUALNE NAPIĘCIE",
    "equipment.Sensores e periféricos": "Czujniki i urządzenia peryferyjne",
    "equipment.Contadores": "Liczniki",
    "equipment.HORAS DE USO DO MOTOR": "GODZINY PRACY SILNIKA",
    "equipment.HORAS DE USO DO MAGNETRON": "GODZINY PRACY MAGNETRONU",
    "equipment.ABERTURAS DE PORTA": "OTWARCIA DRZWI",
    "equipment.ATUAÇÃO DO RELE DA POWER": "DZIAŁANIE PRZEKAŹNIKA MOCY",
    "equipment.ATUAÇÃO DO SENSOR DE PORTA": "DZIAŁANIE CZUJNIKA DRZWI",
    "equipment.RECEITAS EXECUTADAS": "WYKONANE PRZEPISY",
    "equipment.LIMPEZAS EXECUTADAS": "WYKONANE CZYSZCZENIA",
    "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "GODZINY PRACY FILTRA KATALITYCZNEGO",
    "equipment.HORAS DE USO DO FILTRO DE AR": "GODZINY PRACY FILTRA POWIETRZA",
    "equipment.CORRENTE DO MAGNETRON": "PRĄD MAGNETRONU",
    "equipment.Erros": "Błędy",
    "equipment.Desativado": "Dezaktywowany",
    "equipment.Cozinhando": "Gotowanie",
    "equipment.Pré-aquecendo": "Nagrzewanie",
    "equipment.Em espera": "Oczekiwanie",
    "equipment.Limpando": "Czyszczenie",
    "equipment.horas": "godziny",
    "equipment.Ativado": "Aktywowany",
    "equipment.Erro CAN": "Błąd CAN",
    "equipment.Erro no sensor de câmara": "Błąd czujnika kamery",
    "equipment.Alerta de temperatura alta no painel": "Ostrzeżenie: Wysoka temperatura na panelu",
    "equipment.Erro de temperatura alta no painel": "Błąd: Wysoka temperatura na panelu",
    "equipment.Alerta de comunicação no inversor de frequência": "Ostrzeżenie: Błąd komunikacji z falownikiem",
    "equipment.Alerta de status no inversor de frequência": "Ostrzeżenie: Błąd stanu falownika",
    "equipment.Alerta na corrente do magnetron": "Ostrzeżenie: Prąd magnetronu",
    "equipment.Erro no modelo do equipamento": "Błąd modelu urządzenia",
    "equipment.Erro no módulo de energia": "Błąd modułu zasilania",
    "equipment.Erro I2C": "Błąd I2C",
    "equipment.Erro de temperatura alta na placa": "Błąd: Wysoka temperatura na płycie",
    "equipment.Fechado": "Zamknięte",
    "equipment.Aberto": "Otwarte",
    "equipment.Câmara": "Komora",
    "equipment.Placa": "Płyta",
    "equipment.Tensão": "Napięcie",
    "equipment.Corrente da placa": "Prąd płyty",
    "equipment.Velocidade do motor": "Prędkość silnika",
    "equipment.Rele da resistência": "Przekaźnik grzałki",
    "equipment.Rele de curto circuito": "Przekaźnik zwarciowy",
    "equipment.Ventilador radial": "Wentylator promieniowy",
    "equipment.Led vermelho": "Czerwona dioda LED",
    "equipment.Led verde": "Zielona dioda LED",
    "equipment.Led azul": "Niebieska dioda LED",
    "equipment.Erro": "Błąd",
    "equipment.Sensor": "Czujnik",
    "equipment.Valor": "Wartość",
    "equipment.Manutenção da temperatura": "Utrzymanie temperatury",
    "equipment.Manutenção": "Konserwacja",
    "equipment.Esfriando": "Chłodzenie",
    "equipment.CEILING SENSOR ERROR": "Błąd czujnika sufitu",
    "equipment.BALLAST SENSOR ERROR": "Błąd czujnika balastu",
    "equipment.VAPORIZER SENSOR ERROR": "Błąd czujnika parownika",
    "equipment.EQUIPMENT CONSUMPTION": "Zużycie",
    "equipment.Sensores": "Czujniki",
    "equipment.Falta de água": "Brak wody",
    "equipment.Executando Receita": "Uruchamianie przepisu",
    "equipment.Executando Limpeza": "Uruchamianie czyszczenia",
    "equipment.Dia": "Dzień",
    "equipment.Semana": "Tydzień",
    "equipment.Mês": "Miesiąc",
    "equipment.Tempo": "Czas",
    "equipment.Segunda": "Poniedziałek",
    "equipment.Terça": "Wtorek",
    "equipment.Quarta": "Środa",
    "equipment.Quinta": "Czwartek",
    "equipment.Sexta": "Piątek",
    "equipment.Sábado": "Sobota",
    "equipment.Domingo": "Niedziela",
    "equipment.CONSUMO ESTIMADO": "SZACOWANE ZUŻYCIE",
    "equipment.CONSUMO ATUAL": "AKTUALNE ZUŻYCIE",
    "equipment.ECONOMIA COM MODO ECO": "OSZCZĘDNOŚĆ DZIĘKI TRYBOWI ECO",
    "equipment.MÉDIA SEMANAL": "ŚREDNIA TYGODNIOWA",
    "equipment.MÉDIA MENSAL": "ŚREDNIA MIESIĘCZNA",
    "equipment.Consumo de energia": "Zużycie energii",
    "equipment.CONSUMO ACUMULADO": "ZUŻYCIE SKUMULOWANE",
    "equipment.MÉDIA DIÁRIA": "ŚREDNIA DZIENNA",
    "equipment.mês selecionado": "wybrany miesiąc",
    "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "Ta wartość reprezentuje całkowitą sumę zużycia dla każdej godziny dnia.",
    "equipment.Este valor representa a soma total dos consumos de cada dia.": "Ta wartość reprezentuje całkowitą sumę zużycia każdego dnia.",
    "equipment.Este valor representa a soma total dos consumos de cada semana.": "Ta wartość reprezentuje całkowitą sumę zużycia w każdym tygodniu.",
    "equipment.Este valor representa a soma total dos consumos de cada mês.": "Ta wartość reprezentuje całkowitą sumę zużycia w każdym miesiącu.",
    "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "Ta wartość reprezentuje średnie zużycie godzinowe, dostarczając szacunków opartych na twoim użytkowaniu.",
    "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "Ta wartość reprezentuje średnie zużycie dzienne, dostarczając szacunków opartych na twoim użytkowaniu.",
    "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "Ta wartość reprezentuje średnie zużycie tygodniowe, dostarczając szacunków opartych na twoim użytkowaniu.",
    "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "Ta wartość reprezentuje średnie zużycie z ostatnich dwóch miesięcy, dostarczając szacunków opartych na twoim użytkowaniu.",
    "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "Ta wartość reprezentuje całkowitą oszczędność zużycia dla każdej godziny dnia dzięki użyciu trybu Eco.",
    "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "Ta wartość reprezentuje całkowitą oszczędność zużycia każdego dnia dzięki użyciu trybu Eco.",
    "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "Ta wartość reprezentuje całkowitą oszczędność zużycia w tygodniu dzięki użyciu trybu Eco.",
    "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "Ta wartość reprezentuje całkowitą oszczędność zużycia w miesiącu dzięki użyciu trybu Eco.",
    "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "Ta wartość reprezentuje średnie zużycie z ostatnich 7 dni, z wyłączeniem bieżącego dnia.",
    "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "Ta wartość reprezentuje średnie zużycie z ostatnich 4 tygodni.",
    "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "Ta wartość reprezentuje średnie zużycie z ostatnich 2 miesięcy, z wyłączeniem bieżącego miesiąca.",
    "equipment.Lista de consumo de energia": "Lista zużycia energii",
    "equipment.Período": "Okres",
    "equipment.Consumo (kWh)": "Zużycie (kWh)",
    "equipment.Economia com ECO (kWh)": "Oszczędność z ECO (kWh)",
    "equipment.Total": "Suma",
    "equipment.Sensor de RI": "Czujnik RI",
    "equipment.HUMIDITY SENSOR ERROR": "Błąd czujnika wilgotności",
    "equipment.TEMPERATURE SENSOR ERROR": "Błąd czujnika temperatury",
    "equipment.WATER FILTER CLEANING COMPLETED": "Wymiana filtra wody zakończona",
    "equipment.WATER FILTER CLEANING REJECTED": "Wymiana filtra wody odrzucona",
    "equipment.HOOD TURNED ON": "Okap włączony",
    "equipment.HOOD TURNED OFF": "Okap wyłączony",
    "equipment.AUTOMATIC PREHEATING REJECTED": "Automatyczne podgrzewanie odrzucone",
    "equipment.média diária": "średnia dzienna",
    "equipment.média de execução diária": "średnia dzienna liczba wykonań",
    "equipment.FERMENTADORA": "FERMENTATOR",
    "equipment.FORNO": "PIEKARNIK",
    "equipment.DIA": "DZIEŃ",
    "equipment.Baixado": "Pobrano",
    "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia." : "Codzienne czyszczenie urządzenia wspomaga jego prawidłowe działanie i ma wpływ na gwarancję.",
    "equipment.Desde a vinculação do equipamento ao IOK" : "Od momentu powiązania urządzenia z IOK",
    "equipment.Total desde a vinculação do equipamento ao IOK": "Łącznie od momentu powiązania urządzenia z IOK",
    "equipment.Receitas do forno" : "Przepisy pieca",
    "equipment.Receitas da fermentadora" : "Przepisy fermentatora",
    "equipment.FERM." : "FERM.",
    "equipment.Fermentadora" : "Fermentor",
    "equipment.Coifa" : "Okap",
    "equipment.Preaquecimento automático" : "Automatyczne nagrzewanie wstępne",
    "equipment.nivel" : "poziom",
    "equipment.Fermentadora ligada" : "Komora fermentacyjna włączona",
    "equipment.Fermentadora desligada" : "Komora fermentacyjna wyłączona",
    "equipment.Forno desligado" : "Piekarnik wyłączony",
    "equipment.Equipamento ligado" : "Urządzenie włączone",
    "equipment.Equipamento desligado" : "Urządzenie wyłączone",
    "equipment.visualizar haccp": "Wyświetl HACCP",
    "equipment.HACCP": "HACCP",
    "equipment.Atualizar Equip.": "Aktualizuj sprzęt",
    "equipment.Consumo de agua por receita": "Zużycie wody na recepturę",
    "equipment.Consumo de energia por receita": "Zużycie energii na recepturę",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "NADAL BRAK DANYCH DOTYCZĄCYCH ZUŻYCIA WODY NA RECEPTURĘ :(",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "NADAL BRAK DANYCH DOTYCZĄCYCH ZUŻYCIA ENERGII NA RECEPTURĘ :(",
    "equipment.LITROS CONSUMIDOS NO DIA": "LITRY ZUŻYTE W CIĄGU DNIA",
    "equipment.ENERGIA CONSUMIDA NO DIA": "ENERGIA ZUŻYTA W CIĄGU DNIA",
    "equipment.CONSUMO ACUMULADO SEMANAL": "SKUMULOWANE ZUŻYCIE TYGODNIOWE",
    "equipment.CONSUMO ACUMULADO MENSAL": "SKUMULOWANE ZUŻYCIE MIESIĘCZNE",
    "equipment.Receitas": "Receptury",
    "equipment.Consumo (L)": "Zużycie (L)",
    "equipment.Exec. dia - (L)": "Przygotowania/dzień - (L)",
    "equipment.Exec. semana - (L)": "Przygotowania/tydzień - (L)",
    "equipment.Exec. mês - (L)": "Przygotowania/miesiąc - (L)",
    "equipment.Exec. dia - (kWh)": "Przygotowania/dzień - (kWh)",
    "equipment.Exec. semana - (kWh)": "Przygotowania/tydzień - (kWh)",
    "equipment.Exec. mês - (kWh)": "Przygotowania/miesiąc - (kWh)",
    "equipment.Agua consumida (litros)": "Zużyta woda (litry)",
    "equipment.Energia consumida (kWh)": "Zużyta energia (kWh)",
    "equipment.temperatura da câmara" : "Temperatura komory",
    "equipment.temperatura do vapor" : "Temperatura pary",
    "equipment.último evento listado" : "Ostatnie zarejestrowane zdarzenie",
    "equipment.temperatura da sonda" : "Temperatura sondy",
    "equipment.porta" : "Drzwi",
    "equipment.temperatura" : "Temperatura",
    "equipment.temperatura atual" : "Aktualna temperatura",
    "equipment.média de oscilação diária" : "Średnia dzienna amplituda",
    "equipment.oscilação diária da temperatura" : "Dzienna amplituda temperatury",
    "equipment.cleaningType.smart": "Inteligentne czyszczenie",
    "equipment.cleaningType.light": "Lekkie czyszczenie",
    "equipment.cleaningType.medium": "Średnie czyszczenie",
    "equipment.cleaningType.heavy": "Intensywne czyszczenie",
    "equipment.cleaningType.decalcifying": "Czyszczenie odkamieniające",
    "equipment.cleaningType.security": "Czyszczenie bezpieczeństwa",
    "equipment.cleaningType.rinse": "Płukanie",
    "equipment.cleaningType.custom": "Czyszczenie niestandardowe",
    "equipment.cleaningTypeShort.smart": "Inteligentne",
    "equipment.cleaningTypeShort.light": "Lekkie",
    "equipment.cleaningTypeShort.medium": "Średnie",
    "equipment.cleaningTypeShort.heavy": "Intensywne",
    "equipment.cleaningTypeShort.decalcifying": "Odkamienianie",
    "equipment.cleaningTypeShort.security": "Bezpieczeństwo",
    "equipment.cleaningTypeShort.rinse": "Płukanie",
    "equipment.cleaningTypeShort.custom": "Niestandardowe",
    "equipment.temperature.sectionTitle": "Temperatura",
    "equipment.temperature.currentChamber": "AKTUALNA TEMPERATURA KOMORY:",
    "equipment.temperature.currentProbe": "AKTUALNA TEMPERATURA SONDY:",
    "equipment.temperature.currentSteam": "AKTUALNA TEMPERATURA PARY:",
    "equipment.temperature.dailyOscillation": "Dobowe wahania temperatury",
    "equipment.temperature.chamberShort": "Komora",
    "equipment.temperature.probeShort": "Sonda",
    "equipment.temperature.axisLabel": "Temperatura {unit}",
    "equipment.temperature.dailyAverage": "ŚREDNIA DZIENNA",
    "equipment.temperature.weeklyAverage": "ŚREDNIA TYGODNIOWA",
    "equipment.temperature.monthlyAverage": "ŚREDNIA MIESIĘCZNA",
    "equipment.temperature.lastListedEvent": "Ostatnie zarejestrowane zdarzenie",
    "equipment.temperature.door": "Drzwi",
    "equipment.temperature.open": "OTWARTE",
    "equipment.temperature.closed": "ZAMKNIĘTE",
    "equipment.temperature.defineTimeRange": "Ustal zakres czasu:",
    "equipment.temperature.until": "do",
    "equipment.gerar gráficos" : "generować wykresy",
    "equipment.Realizada": "Wyk.",
    "equipment.Recomendada": "Zalec.",
    "equipment.Dias da semana" : "Dni tygodnia",
    "equipment.Horário 24h" : "Format 24-godzinny",
    "equipment.seg" : "Pon",
    "equipment.ter" : "Wt",
    "equipment.qua" : "Śr",
    "equipment.qui" : "Czw",
    "equipment.sex" : "Pt",
    "equipment.sab" : "Sob",
    "equipment.dom" : "Nd",
    "equipment.Desconhecido" : "Nieznany",
    "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(" : "NADAL BRAK DANYCH DOTYCZĄCYCH ZUŻYCIA ENERGII :(",
    "equipment.monthShort.Jan": "Sty",
    "equipment.monthShort.Fev": "Lut",
    "equipment.monthShort.Mar": "Mar",
    "equipment.monthShort.Abr": "Kwi",
    "equipment.monthShort.Mai": "Maj",
    "equipment.monthShort.Jun": "Cze",
    "equipment.monthShort.Jul": "Lip",
    "equipment.monthShort.Ago": "Sie",
    "equipment.monthShort.Set": "Wrz",
    "equipment.monthShort.Out": "Paź",
    "equipment.monthShort.Nov": "Lis",
    "equipment.monthShort.Dez": "Gru",
    "equipment.settingsChange.category": "Zmiana parametrów",
    "equipment.settingsChange.factoryTitle": "Zmiana parametru technicznego",
    "equipment.settingsChange.userTitle": "Zmiana parametru użytkownika",
    "equipment.settingsChange.changedTo": "{label} zmieniono na {value}",
    "equipment.settingsChange.hardResetExecuted": "Wykonano hard reset",
    "equipment.settingsChange.userFactoryResetExecuted": "Wykonano przywrócenie ustawień fabrycznych użytkownika",
    "equipment.settingsChange.magSensorEnabled": "czujnik magnetronu",
    "equipment.settingsChange.serialNumber": "numer seryjny",
    "equipment.settingsChange.manufactureDate": "data produkcji",
    "equipment.settingsChange.inverterType": "typ falownika",
    "equipment.settingsChange.preHeatMotorSpeed": "prędkość silnika podgrzewania wstępnego",
    "equipment.settingsChange.voltage": "napięcie",
    "equipment.settingsChange.oemModeEnabled": "tryb OEM",
    "equipment.settingsChange.controlDoor": "sterowanie drzwiami",
    "equipment.settingsChange.hardReset": "hard reset",
    "equipment.settingsChange.preHeatTemperatureOne": "temperatura podgrzewania wstępnego 1",
    "equipment.settingsChange.preHeatTemperatureTwo": "temperatura podgrzewania wstępnego 2",
    "equipment.settingsChange.preHeatTime": "czas podgrzewania wstępnego",
    "equipment.settingsChange.preHeatTwoEnabled": "podgrzewanie wstępne 2",
    "equipment.settingsChange.userFactoryReset": "przywrócenie ustawień fabrycznych użytkownika",
    "equipment.settingsChange.enableManualMode": "tryb ręczny",
    "equipment.settingsChange.enableFavorites": "ulubione",
    "equipment.settingsChange.enableHeatBrown": "mocniejsze podgrzewanie/przyrumienianie",
    "equipment.settingsChange.enableRepeatRecipe": "powtórz recepturę",
    "equipment.settingsChange.enableOperatorMode": "tryb operatora",
    "equipment.settingsChange.enableAutoImport": "automatyczny import",
    "equipment.settingsChange.enableRecipePreRunMessage": "komunikat przed przygotowaniem receptury",
    "equipment.settingsChange.controlDoorTwoInputs": "2 wejścia",
    "equipment.settingsChange.controlDoorThreeInputs": "3 wejścia",
    
    //LOJAS
    "store.Procurar loja": "Wyszukaj sklep",
    "store.Excluir": "Usuń",
    "store.Editar": "Edytuj",
    "store.nome": "Nazwa",
    "store.equipamentos": "Sprzęt",
    "store.Equipamentos vinculados": "Powiązane urządzenia",
    "store.cidade": "Miasto",
    "store.estado": "Stan",
    "store.salvar": "Zapisz",
    "store.cadastrar loja": "zarejestruj sklep",
    "store.Nome fantasia": "Nazwa fantazyjna",
    "store.Preencha o nome da loja": "Wypełnij nazwę sklepu",
    "store.CNPJ": "CNPJ",
    "store.Preencha o CNPJ da loja": "Wypełnij numer CNPJ sklepu",
    "store.CEP": "Kod pocztowy",
    "store.Preencha o CEP da loja": "Wypełnij kod pocztowy sklepu",
    "store.Informe o nome fantasia": "Wypełnij nazwę fantazyjną",
    "store.Cidade": "Miasto",
    "store.Informe a cidade": "Podaj miasto",
    "store.Preencha a cidade": "Wypełnij miasto",
    "store.UF": "Stan",
    "store.Preencha o UF da loja": "Wypełnij stan sklepu",
    "store.Bairro": "Dzielnica",
    "store.Informe o bairro": "Podaj dzielnicę",
    "store.Preencha o bairro da loja": "Wypełnij dzielnicę sklepu",
    "store.Endereço": "Adres",
    "store.Informe o endereço": "Podaj adres",
    "store.Preencha o endereço da loja": "Wypełnij adres sklepu",
    "store.Nº": "Numer",
    "store.Loja cadastrada com sucesso": "Sklep zarejestrowany pomyślnie",
    "store.Erro ao adicionar loja. Tente novamente": "Błąd podczas dodawania sklepu. Spróbuj ponownie",
    "store.Loja deletada com sucesso": "Sklep usunięty pomyślnie",
    "store.Erro ao deletar loja. Tente novamente mais tarde": "Błąd podczas usuwania sklepu. Spróbuj ponownie później",
    "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "NIE MA JESZCZE ZAREJESTROWANYCH SKLEPÓW :(",
    "store.EXCLUIR LOJA": "USUŃ SKLEP",
    "store.Você deseja excluir a loja da plataforma IOK?": "Czy chcesz usunąć sklep z platformy IOK?",
    "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "W ten sposób sprzęt z nim powiązany nie będzie powiązany z żadnym sklepem, chyba że ponownie je połączysz.",
    "store.loja editada com sucesso": "Sklep edytowany pomyślnie",
    "store.não foi possível editar a loja. Tente novamente mais tarde": "Nie udało się edytować sklepu. Spróbuj ponownie później",
    "store.editar loja": "Edytuj sklep",
    "store.Procurar grupo de equipamentos": "Wyszukaj grupę sprzętu",
    "store.cadastrar grupo": "zarejestruj grupę",
    "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "NIE MA JESZCZE ZAREJESTROWANEJ GRUPY :(",
    "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "Kliknij przycisk znajdujący się w prawym górnym rogu i dodaj grupy.",
    "store.cadastrar grupo de equipamentos": "zarejestruj grupę sprzętu",
    "store.grupo de equipamentos cadastrado com sucesso!": "Grupa sprzętu została pomyślnie zarejestrowana!",
    "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "Nie można zarejestrować grupy. Spróbuj ponownie później",
    "store.Nome do grupo": "Nazwa grupy",
    "store.informe o nome do grupo": "Wprowadź nazwę grupy",
    "store.preencha o nome do grupo": "Wpisz nazwę grupy",
    "store.Grupo de equipamentos deletado com sucesso!": "Grupa sprzętu została pomyślnie usunięta!",
    "store.Erro ao deletar o grupo. Tente novamente mais tarde": "Błąd podczas usuwania grupy. Spróbuj ponownie później",
    "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "USUŃ GRUPĘ SPRZĘTU",
    "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "Czy chcesz usunąć tę grupę sprzętu z platformy IOK?",
    "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "Gdy to zrobisz, powiązane z nim wyposażenie nie zostanie połączone z żadną grupą, chyba że połączysz je ponownie.",
    "store.grupo de equipamentos editado com sucesso!": "Grupa sprzętu została pomyślnie zmodyfikowana!",
    "store.não foi possível editar o grupo. Tente novamente mais tarde": "Nie można edytować grupy. Spróbuj ponownie później",
    "store.editar grupo de equipamentos": "edytować grupę sprzętu",
    "store.CEP não encontrado no Brasil": "Nie znaleziono kodu pocztowego w Brazylii",
    "store.Cadastrar": "Zarejestruj",
    "store.Equipamentos vinculados": "Powiązane urządzenia",
    
    //NAVBAR
    "navbar.home": "strona główna",
    "navbar.cookbook": "książka kucharska",
    "navbar.my menus": "moje menu",
    "navbar.equipment": "sprzęt",
    "navbar.users": "użytkownicy",
    "navbar.calls": "usługi",
    "navbar.settings": "ustawienia",
    "navbar.help": "pomoc",
    "navbar.logout": "wyloguj",
    "navbar.Editar conta": "Edytuj konto",
    "navbar.API Externa": "Zewnętrzne API",
    "navbar.companhias": "Firmy",
    "navbar.information": "Informacje IOK",
    
    //FOOTERBAR
    "footerBar.menu": "Menu",
    "footerBar.cookbook": "Książka kucharska",
    "footerBar.home": "Strona główna",
    "footerBar.menus": "Menu",
    "footerBar.notifications": "Powiadomienia",
    
    //ATENDIMENTOS
    "calls.ATENDIMENTOS EM ABERTO": "TRWAJĄCE USŁUGI",
    "calls.ATENDIMENTOS ENCERRADOS": "ZAKOŃCZONE USŁUGI",
    
    //MAPA
    "map.título": "Lokalizacja",
    "map.erro": "Błąd",
    "map.mensagem de erro": "Nie można wczytać mapy",
    "map.Localização não disponível": "Lokalizacja niedostępna",
    
    //MODAL
    "modal.CONFIRMAR": "POTWIERDŹ",
    "modal.Salvar alterações": "Zapisz edycje",
    "Modal.Há alterações não salvas nos parâmetros dos passos": "Istnieją niezapisane zmiany w parametrach kroku",
    "Modal.Como deseja proceder?": "Jak chcesz postąpić?",
    "Modal.Avaliar alterações realizadas": "Ocen zmiany",
    "Modal.Descartar alterações": "Odrzuć zmiany",
    
    //USUÁRIOS
    "user.Nome": "Imię",
    "user.E-mail": "E-mail",
    "user.Permissão": "Uprawnienia",
    "user.Loja": "Sklep",
    "user.Status": "Status",
    "user.Excluir": "Usuń",
    "user.Editar": "Edytuj",
    "user.Procurar usuário": "Szukaj użytkownika",
    "user.ADICIONAR USUÁRIO": "DODAJ UŻYTKOWNIKA",
    "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "JESZCZE NIE ZAREJESTROWANO ŻADNYCH UŻYTKOWNIKÓW :(",
    "user.+ Usuário": "+ Użytkownik",
    "user.Informe o nome do usuário": "Podaj nazwę użytkownika",
    "user.Preencha o nome do usuário": "Wypełnij nazwę użytkownika",
    "user.Informe o e-mail do usuário": "Podaj adres e-mail użytkownika",
    "user.Preencha com um e-mail válido": "Podaj poprawny adres e-mail",
    "user.Administrador": "Administrator",
    "user.Usuário": "Użytkownik",
    "user.Preencha o telefone do usuário": "Podaj numer telefonu użytkownika",
    "user.Selecione a permissão do usuário": "Wybierz uprawnienia użytkownika",
    "user.Ativo": "Aktywny",
    "user.Inativo": "Nieaktywny",
    "user.Usuário deletado da plataforma com sucesso!": "Użytkownik pomyślnie usunięty z platformy!",
    "user.Ocorreu um erro. Tente novamente mais tarde": "Wystąpił błąd. Spróbuj ponownie później",
    "user.EXCLUIR USUÁRIO": "USUŃ UŻYTKOWNIKA",
    "user.delete.paragrafo 1": "Czy chcesz usunąć użytkownika z platformy IOK?",
    "user.delete.paragrafo 2": "W ten sposób straci on dostęp do wszystkich narzędzi platformy, chyba że zostanie ponownie dodany, postępując zgodnie z instrukcjami rejestracji.",
    "user.EDITAR USUÁRIO": "EDYTUJ UŻYTKOWNIKA",
    "user.Usuário editado com sucesso!": "Użytkownik pomyślnie edytowany!",
    "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "Nie udało się edytować tego użytkownika. Spróbuj ponownie później",
    "user.INFORMAÇÕES DO USUÁRIO": "INFORMACJE O UŻYTKOWNIKU",
    "user.Telefone": "Numer telefonu",
    "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "Nie udało się zarejestrować tego użytkownika. Spróbuj ponownie później",
    "user.Usuário adicionado com sucesso!": "Użytkownik dodany pomyślnie!",
    "user.CRIAR TIPO DE USUÁRIO": "UTWÓRZ RODZAJ UŻYTKOWNIKA",
    "user.Criar novo tipo de usuário": "Utwórz nowy typ użytkownika",
    "user.Adicionar novo usuário": "Dodaj nowego użytkownika",
    "user.Permissões": "Uprawnienia",
    "user.Preencha o nome do novo tipo de usuário": "Wypełnij nazwę nowego rodzaju użytkownika",
    "user.Selecione pelo menos uma permissão": "Wybierz co najmniej jedno uprawnienie",
    "user.Não foi possível carregar as permissões": "Nie udało się załadować uprawnień",
    "user.Tipo de usuário criado com sucesso!": "Rodzaj użytkownika utworzony pomyślnie!",
    "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "Nie udało się utworzyć tego nowego rodzaju użytkownika. Spróbuj ponownie później",
    "user.Não foi possível carregar os tipos de usuário da companhia": "Nie udało się załadować rodzajów użytkowników firmy",
    "user.Tipo de usuário": "Rodzaj użytkownika",
    "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "E-mail już zarejestrowany na platformie. Podaj nowy adres e-mail",
    "user.UNIR CONTAS": "POŁĄCZ KONTA",
    "user.ID da companhia": "Identyfikator firmy",
    "user.Digite o ID da companhia que deseja unir a sua conta": "Wpisz identyfikator firmy, z którą chcesz połączyć swoje konto",
    "user.Preencha o ID da companhia": "Wypełnij identyfikator firmy",
    "user.O administrador da conta com a qual deseja se unir poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.":
    "Administrator konta, do którego chcesz dołączyć, będzie mógł znaleźć identyfikator klikając na Twoją nazwę użytkownika, znajdującą się w górnym menu, w prawym rogu ekranu.",
    "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!":
    "Administrator drugiego konta otrzyma wiadomość e-mail z prośbą o zaakceptowanie Twojej prośby. Po zaakceptowaniu oba konta zostaną połączone!",
    "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "Nie można poprosić o połączenie kont. Potwierdź identyfikator lub spróbuj później",
    "user.SOLICITAÇÃO APROVADA COM SUCESSO": "WNIOSEK POMYŚLNIE ZATWIERDZONY",
    "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "PROSZĘ CZEKAĆ, aż PODŁĄCZymy KONTA. PROCES TEN MOŻE ZAJĄĆ KILKA MINUT...",
    "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "UNIA KONT ZAKOŃCZONA POMYŚLNIE! ABY WEJŚĆ NA PLATFORMĘ, KLIKNIJ PRZYCISK PONIŻEJ.",
    "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM NOSSO SUPORTE.":
    "NIE MAMY MOŻLIWOŚCI ŁĄCZENIA KONT. PROSZĘ SPRÓBUJ PONOWNIE. JEŚLI PROBLEM W dalszym ciągu występuje, PROSIMY O KONTAKT Z NASZYM WSPARCIEM.",
    "user.possui todos os acessos": "ma pełny dostęp",
    "user.possui o acesso das abas cookbook, meus menus e equipamentos": "ma dostęp do książki kucharskiej, moich menu i zakładek wyposażenia",
    "user.possui apenas o acesso da aba cookbook": "ma dostęp tylko do zakładki Książka kucharska",
    "user.possui apenas o acesso da aba equipamentos": "ma dostęp tylko do zakładki wyposażenia",
    "user.possui apenas o acesso da aba meus menus": "ma dostęp tylko do karty Moje menu",
    "user.Grupo de equipamentos": "Grupa sprzętu",
    "user.Informe o telefone do usuário": "Wprowadź numer telefonu użytkownika",
    "user.Nenhum grupo criado": "Nie utworzono żadnych grup",
    "user.Digite o ID da companhia que terá acesso à sua conta": "Wpisz identyfikator firmy, która będzie miała dostęp do Twojego konta",
    "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.":
    "Podając identyfikator do łączenia kont z Twoją firmą miej świadomość, że nowy użytkownik stanie się jednocześnie Administratorem konta Twojej firmy. Warto poinformować, że z chwilą wyrażenia przez użytkownika zgody na dołączenie kont w Twojej firmie, należąca do niego firma przestanie istnieć.",
    "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "Przykład: Twoje konto: 001 | Inne konto: 111. Po połączeniu kont drugie konto otrzyma numer 001.",
    "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "Administrator drugiego konta będzie mógł zlokalizować identyfikator klikając na Twoją nazwę użytkownika, znajdującą się w górnym menu, w prawym rogu ekranu.",
    "user.Tela de Equipamentos": "Ekran Sprzętu",
    "user.Tela de Meus Menus": "Ekran Moich Menu",
    "user.Tela do Cookbook": "Ekran Książki Kucharskiej",
    "user.Tela de Usuários": "Ekran Użytkowników",
    "user.Aba de Suporte": "Zakładka Wsparcia",
    "user.Usuário Comum": "Zwykły Użytkownik",
    "user.Usuário do Cookbook": "Użytkownik Książki Przepisów",
    "user.Usuário de Equipamentos": "Użytkownik Sprzętu",
    "user.Usuário de Meus Menus": "Użytkownik Moich Menu",
    "user.Você deseja excluir seu acesso da plataforma IOK?": "Czy chcesz usunąć swój dostęp do platformy IOK?",
    "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "W ten sposób stracisz dostęp do wszystkich narzędzi platformy, a aby ponownie uzyskać dostęp, musisz zostać do niej dodany.",
    "user.CONFIRMAÇÃO": "POTWIERDZENIE",
    "user.Confirme sua senha": "Potwierdź swoje hasło",
    "user.Senha incorreta": "Nieprawidłowe hasło",
    "menus.Os equipamentos e menus criados por ele serão transferidos para o seu nome": "Sprzęt i menu utworzone przez niego zostaną przeniesione na Twoje nazwisko.",
    
    //TUTORIAIS
    "tutorial.Fechar": "Zakończ",
    "tutorial.Fim": "Koniec",
    "tutorial.Próximo": "Następny",
    "tutorial.Abrir": "Otwarty",
    "tutorial.Pular tutorial": "Pomiń tutorial",
    "tutorial.Editar detalhes da receita": "Edytuj szczegóły przepisu",
    "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.": "Teraz możesz dodać więcej szczegółów do swoich przepisów i uczynić je jeszcze pełniejszymi. Kliknij Edytuj szczegóły i podaj wymagane informacje.",
    "tutorial.Salvar edição da receita": "Zapisz edycję przepisu",
    "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "Po wprowadzeniu dalszych szczegółów przepisu kliknij Zapisz.",
    "tutorial.Editar registro de um equipamento": "Edytuj rejestrację sprzętu",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Categoria e Loja.": "Aby dokończyć rejestrację swojego sprzętu, otwórz menu boczne, kliknij Edytuj i uzupełnij informacje o kategorii i sklepie.",
    "tutorial.Editar usuário": "Edytuj użytkownika",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente a Loja a qual ele faz parte.": "Aby dokończyć rejestrację użytkownika, należy otworzyć menu boczne, kliknąć Edytuj i uzupełnić informacje dotyczące Sklepu, do którego należy.",
    "tutorial.Salvar edições de um equipamento": "Zapisywanie zmian na urządzeniu",
    "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "Po zakończeniu rejestracji swojego sprzętu kliknij Zapisz.",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Klikając na linię sprzętu zarejestrowanego w sklepie, możesz zobaczyć więcej statystyk i informacji na jego temat, a także możesz poprosić o usługę lub uruchomić aktualizacje.",
    "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.": "Aby zobaczyć więcej informacji o sklepie, takich jak lokalizacja i najczęściej przygotowywane przepisy, kliknij w wiersz jednostki, którą chcesz przeanalizować.",
    "tutorial.Criar receita": "Utwórz przepis",
    "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.": "W książce kucharskiej możesz tworzyć własne przepisy! Kliknij opcję Utwórz przepis i podaj wszystkie niezbędne informacje.",
    "tutorial.Editar ou excluir um usuário": "Edytuj lub usuń użytkownika",
    "tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.": "Aby usunąć lub edytować dane już zarejestrowanego użytkownika, kliknij menu boczne i wybierz żądaną opcję.",
    "tutorial.Gerenciamento de usuários": "Zarządzanie użytkownikami",
    "tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "Tutaj możesz łatwiej zarządzać swoimi użytkownikami. Klikając + Użytkownik, możesz dodać nowego użytkownika lub utworzyć nowy typ użytkownika.",
    "tutorial.Suas receitas": "Twoje przepisy",
    "tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do cookbook da Prática e também as criadas por você.": "Dzięki książce kucharskiej znajdziesz także własne przepisy, a także możliwość ich tworzenia! Kliknij opcję Zapisane przepisy, aby wyświetlić przepisy zapisane z Praktycznej książki kucharskiej, a także te utworzone przez Ciebie.",
    "tutorial.Filtros do Cookbook": "Filtry do książek kucharskich",
    "tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.": "Aby ułatwić przeglądanie przepisów, możesz zastosować do nich filtry. Wystarczy kliknąć żądany filtr i wybrać jedną z jego opcji.",
    "tutorial.Cookbook": "Książka kucharska",
    "tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.": "W książce kucharskiej, w zakładce Dostępne przepisy, znajdziesz przepisy stworzone przez praktykujących szefów kuchni i możesz z nich korzystać, kiedy tylko chcesz.",
    "tutorial.Atualizar equipamentos": "Aktualizuj sprzęt",
    "tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen drive. Depois disso, clique em Confirmar.": "Aby wysłać aktualizację do swojego sprzętu, kliknij Aktualizuj sprzęt, wybierz modele, które chcesz zaktualizować i sposób, w jaki chcesz przeprowadzić tę aktualizację - przez Wi-Fi lub pendrive. Następnie kliknij Potwierdź.",
    "tutorial.Adicionar equipamento": "Dodaj sprzęt",
    "tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.": "Aby dodać sprzęt do swojego konta, kliknij Dodaj sprzęt i podaj informacje modalne. Następnie kliknij Zapisz.",
    "tutorial.Editar equipamento": "Edytuj sprzęt",
    "tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.": "Aby odłączyć urządzenie lub edytować jego informacje, kliknij menu boczne i wybierz żądaną opcję.",
    "tutorial.Seus equipamentos": "Twój sprzęt",
    "tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "Tutaj zobaczysz cały sprzęt zarejestrowany na Twojej platformie.",
    "tutorial.Restaurar arquivos": "Przywróć pliki",
    "tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.": "Aby przywrócić usunięty plik lub trwale go usunąć, kliknij menu boczne i wybierz żądaną opcję.",
    "tutorial.Lixeira": "Kosz",
    "tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "Usunięte menu będą przechowywane w Koszu przez 30 dni. Po tym okresie zostaną one trwale usunięte.",
    "tutorial.Salvar edições de usuário": "Zapisz zmiany użytkownika",
    "tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "Po zakończeniu rejestracji użytkownika kliknij Zapisz.",
    "tutorial.Criar menu": "Utwórz menu",
    "tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.": "Aby utworzyć i dostosować menu, kliknij opcję Utwórz menu i podaj niezbędne informacje w modalu. Możesz edytować menu w dowolnym momencie.",
    "tutorial.Importar menu": "Importuj menu",
    "tutorial.Para importar um menu, clique em Importar Menu e selecione o modelo e versão do equipamento.": "Aby zaimportować menu, kliknij opcję Importuj menu i wybierz model oraz wersję sprzętu.",
    "tutorial.Criar grupo": "Stworzyć grupę",
    "tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "Aby uporządkować przepisy w grupy, kliknij opcję Utwórz grupę i wprowadź niezbędne informacje w formularzu.",
    "tutorial.Tipos de usuário": "Typy użytkowników",
    "tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "Możesz teraz tworzyć typy użytkowników z określonymi uprawnieniami, aby lepiej służyć Twojej organizacji.",
    "tutorial.Gerenciamento de contas": "Zarządzanie kontem",
    "tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "Jeśli inna osoba w Twojej organizacji również przeprowadziła migrację swojego głównego konta firmowego, w tym miejscu możesz połączyć oba konta.",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "Aby dokończyć rejestrację swojego sprzętu, otwórz menu boczne, kliknij Edytuj i uzupełnij informacje o Grupie.",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "Aby dokończyć rejestrację użytkownika należy otworzyć menu boczne, kliknąć Edytuj i uzupełnić informacje dotyczące Grupy Sprzętu, do której należy.",
    "tutorial.Grupos de equipamentos": "Grupy wyposażenia",
    "tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "W zakładce Grupy możesz przeglądać zarejestrowane grupy oraz rozdzielony pomiędzy nimi sprzęt. Ponadto możliwa jest rejestracja nowych grup oraz edycja już zarejestrowanych.",
    "tutorial.Detalhes de grupos": "Szczegóły grupy",
    "tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "Aby wyświetlić więcej informacji o grupie, takich jak lokalizacja i najczęściej przygotowane przepisy, kliknij na wiersz, który chcesz przeanalizować.",
    "tutorial.Equipamentos em grupos": "Sprzęt w grupach",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Klikając linię urządzenia zarejestrowanego w grupie, możesz wyświetlić więcej statystyk i informacji na jego temat, a także możesz poprosić o usługę lub uruchomić aktualizacje.",
    "tutorial.Grupos": "Grupy",
    "tutorial.Atualização e cache": "Aktualizuj i buforuj",
    "tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "Aby zaktualizować platformę i rozwiązać wszelkie problemy z pamięcią podręczną, kliknij tutaj.",
    "tutorial.Dados dos equipamentos": "Dane urządzeń",
    "tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais preparadas, limpezas realizadas e outros dados relevantes.": "Klikając na wiersz urządzenia, możesz wyświetlić więcej statystyk i informacji o nim, takich jak najczęściej przygotowane przepisy, wykonane czyszczenia i inne istotne dane.",
    "tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "Aby zmienić język swojej platformy, kliknij Język i wybierz żądany język.",
    "tutorial.Alterar idioma": "Zmień język",
    "tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "Aby edytować lub skonfigurować swoje konto, kliknij swoje imię i nazwisko i wybierz żądaną opcję.",
    "tutorial.Editar conta": "Edytuj konto",
    "tutorial.Total de Usuários Cadastrados em sua conta.": "Całkowita liczba użytkowników zarejestrowanych na Twoim koncie.",
    "tutorial.Home": "Strona główna",
    "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "Lokalizacja Twojego sprzętu, umożliwiająca poszerzenie mapy w celu lepszego przeglądania;",
    "tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "Aktualizacje dotyczące wersji sprzętu powiązanego z Twoim kontem;",
    "tutorial.Total de Receitas Cadastradas;": "Całkowity zarejestrowany dochód;",
    "tutorial.Menus Disponíveis;": "Dostępne menu;",
    "tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;" : "To jest Twoja strona główna! Tutaj znajdziesz ogólne podsumowanie swojego konta;",
    "tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "Kliknij karty menu, aby poznać platformę i odkryć wszystko, co ma do zaoferowania.",
    "tutorial.Exportar menu": "Eksportuj menu",
    "tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou por pen drive.": "Po dostosowaniu menu wyeksportuj je na swoje urządzenia przez internet lub pendrive.",
    "tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "Na karcie Lokalizacja możesz przeglądać już zarejestrowane adresy, a także tworzyć dokładne lokalizacje, aby powiązać z nimi swój sprzęt.",
    "tutorial.Localização": "Lokalizacja",
    "tutorial.Informações sobre o equipamento": "Informacje o sprzęcie",
    "tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;" : "Podłączone urządzenia oraz liczba urządzeń przesyłających dane o użytkowaniu;",
    
    //RECOVER ACCOUNT
    "recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "Aby kontynuować, wybierz kategorię, do której pasujesz:",
    "recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua conta clicando em EMPRESA e entre em contato conosco para liberarmos os demais acessos.": "Czy chcesz uzyskać dostęp do platformy jako DYSTRYBUTOR? Utwórz swoje konto, klikając na FIRMA i skontaktuj się z nami, aby odblokować inne dostępy.",
    "recoverAccount.A qual organização você pertence": "Do której organizacji należysz?",
    
    //RECOVER PASSWORD
    "recoverPassword.E-mail para recuperação de senha": "E-mail do odzyskiwania hasła",
    "recoverPassword.Informe o e-mail cadastrado na plataforma": "Podaj e-mail zarejestrowany na platformie",
    "recoverPassword.E-mail inválido. Por favor, verifique": "Nieprawidłowy adres e-mail. Proszę sprawdź",
    "recoverPassword.RECUPERAR SENHA": "ODZYSKAJ HASŁO",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA": "WKRÓTCE OTRZYMASZ E-MAIL Z LINKIEM DO ODZYSKANIA HASŁA",
    "recoverPassword.Login": "Zaloguj się",
    "recoverPassword.Informe seu e-mail": "Podaj swój adres e-mail",
    "recoverPassword.Crie uma nova senha": "Utwórz nowe hasło",
    "recoverPassword.O campo senha deve conter no mínimo 6 caracteres": "Pole hasła musi mieć co najmniej 6 znaków",
    "recoverPassword.Confirme sua senha": "Potwierdź hasło",
    "recoverPassword.As senhas devem ser iguais": "Hasła muszą być zgodne",
    "recoverPassword.ENTRAR": "WPROWADŹ",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE": "WKRÓTCE OTRZYMASZ E-MAIL Z POTWIERDZENIEM TWOJEJ TOŻSAMOŚCI",
    "recoverPassword.CONTINUAR": "KONTYNUUJ",
    "recoverPassword.CONFIRMAR": "POTWIERDŹ",
    "recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.": "Ze względów bezpieczeństwa dostęp do konta został zablokowany z powodu nieprawidłowych prób logowania.",
    "recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:": "Aby odblokować swoje konto, postępuj zgodnie z instrukcjami po kliknięciu przycisku poniżej:",
    "recoverPassword.Desbloquear conta": "Odblokuj konto",
    "recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.": "Otrzymałeś e-mail, aby rozpocząć odblokowywanie konta.",
    "recoverPassword.Verifique sua caixa de entrada ou spam.": "Sprawdź swoją skrzynkę odbiorczą lub folder spamu.",
    "recoverPassword.Verifique seu e-mail": "Sprawdź swój e-mail.",
    "recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.": "Podaj swój e-mail logowania i utwórz nowe hasło, aby uzyskać dostęp do swojego konta.",
    
    // EXPORT
    "export.Limpezas": "Czyszczenia",
    "export.Eventos": "Wydarzenia",
    "export.Lista de receitas preparadas": "Lista przygotowanych przepisów",
    "export.Lista de limpezas realizadas": "Lista przeprowadzonych czyszczeń",
    "export.Lista de eventos ocorridos": "Lista występujących zdarzeń",
    "export.Exportar dados": "Eksportuj dane",
    "export.Exportar": "Eksportuj",
    "export.Informações do equipamento": "Informacje o urządzeniu",
    "export.Dados exportados com sucesso!": "Dane zostały pomyślnie wyeksportowane!",
    "export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "Nie można wyeksportować danych. Proszę spróbować ponownie później.",
    "export.Detalhes do menu": "Szczegóły menu",
    "export.Detalhes de receitas": "Szczegóły przepisów",
    "export.Detalhes e Passos": "Szczegóły i Kroki",
    "export.Exportando dados. Em breve o arquivo estará disponível!": "Eksportowanie danych. Plik będzie wkrótce dostępny!",
    "export.Resumo dos passos": "Podsumowanie kroków",
    "export.salvar imagem": "zapisz obraz",
    "export.Nenhum modelo foi selecionado": "Nie wybrano żadnego modelu",
    
    // COMPANIES PAGE
    "company.Procurar companhia": "Szukaj firmy",
    "company.Adicionar companhia": "Dodaj firmę",
    "company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "NIE MA JESZCZE ZAREJESTROWANYCH FIRM :(",
    "company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "Kliknij przycisk znajdujący się w prawym górnym rogu i dodaj firmy.",
    "company.Adicionar": "Dodaj",
    "company.ADICIONAR EQUIPAMENTOS": "DODAJ SPRZĘT",
    "company.Preencha pelo menos um número de série": "Wprowadź co najmniej jeden numer seryjny",
    "company.Informe os números de série": "Podaj numery seryjne",
    "company.Número de série": "Numer seryjny",
    "company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "Aby dodać wiele urządzeń, oddziel je średnikiem (;).",
    "company.Informe o número de série do equipamento que deseja adicionar abaixo.": "Wprowadź poniżej numer seryjny urządzenia, które chcesz dodać.",
    "company.Números de série adicionados com sucesso!": "Numery seryjne zostały pomyślnie dodane!",
    "company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "Nie udało się dodać numerów seryjnych. Spróbuj ponownie później.",
    "company.adicionar": "dodać",
    "company.Procurar por companhia ou ID": "Szukaj firmy lub ID",
    "company.Companhia": "Firma",
    "company.E-mail principal": "Główny e-mail",
    "company.Local": "Lokalizacja",
    "company.Companhia adicionada com sucesso!": "Firma została pomyślnie dodana!",
    "company.Não foi possível cadastrar a companhia": "Nie można było zarejestrować firmy",
    "company.REMOVER COMPANHIA": "USUŃ FIRMĘ",
    "company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "Czy na pewno chcesz trwale usunąć firmę? Powiązany z nią sprzęt również zostanie usunięty z Twojego konta.",
    "company.Esta ação não poderá ser desfeita.": "Tej operacji nie można cofnąć.",
    "company.A companhia foi removida com sucesso!": "Firma została pomyślnie usunięta!",
    "company.Não foi possível remover a companhia": "Nie udało się usunąć firmy",
    "company.Quant. de fornos": "Liczba pieców",
    "company.Fornos conectados": "Podłączone piece",
    "company.Fornos não conectados": "Niepodłączone piece",
    "company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "NIE MA JESZCZE ZAREJESTROWANEGO SPRZĘTU :(",
    "company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "Kliknij przycisk znajdujący się w prawym górnym rogu i dodaj sprzęt.",
    "company.excluir equipamento": "Usuń urządzenie",
    "company.Você deseja excluir o equipamento selecionado definitivamente?": "Czy na pewno chcesz trwale usunąć wybrane urządzenie?",
    "company.Número de série editado com sucesso!": "Numer seryjny został pomyślnie edytowany!",
    "company.Não foi possível editar o número de série. Tente novamente mais tarde": "Nie można edytować numeru seryjnego. Spróbuj ponownie później.",
    "company.Informe o número de série": "Wprowadź numer seryjny",
    "company.Preencha um número de série": "Uzupełnij numer seryjny",
    "company.EDITAR EQUIPAMENTO": "EDYTUJ SPRZĘT",
    "company.Modelo": "Model",
    "company.Cadastro": "Rejestracja",
    "company.Conectado": "Połączony",
    "company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "WYBIERZ SPRZĘT DO USUNIĘCIA",
    "company.O equipamento foi removida com sucesso!": "Sprzęt został pomyślnie usunięty!",
    "company.Não foi possível remover o equipamento": "Nie udało się usunąć sprzętu",
    "company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "Znaki specjalne nie są dozwolone, z wyjątkiem średnika (';')",
    "company.Preencha o número de série sem caracteres especiais": "Wprowadź numer seryjny bez znaków specjalnych",
    "company.Um ou mais números de série já estão provisionados para outra companhia": "Co najmniej jeden numer seryjny jest już przypisany do innej firmy.",
    "company.Um ou mais números de série já estão conectados na conta de outra companhia": "Co najmniej jeden numer seryjny jest już połączony z kontem innej firmy.",
    
    // Error
    "error.Ocorreu um erro ao carregar esta seção": "Wystąpił błąd podczas ładowania tej sekcji",
    "error.Tentar novamente": "Spróbuj ponownie",
    
    //DASHBOARDS
    "dashboard.fornos vinculados" : "POŁĄCZONE PIECE",
    "dashboard.ativos" : "Aktywne",
    "dashboard.inativos" : " Nieaktywne",
    "dashboard.sem status" : " Brak statusu",
    "dashboard.fornos atualizados" : "ZAKTUALIZOWANE PIECE",
    "dashboard.com a versão do software mais recente" : "Z najnowszą wersją oprogramowania",
    "dashboard.chamados" : "ZGŁOSZENIA SERWISOWE",
    "dashboard.veja mais no app cliente" : "Zobacz więcej w aplikacji klienta",
    "dashboard.limpeza diária" : "CODZIENNE CZYSZCZENIE",
    "dashboard.dos fornos estão em dia" : "piece są na bieżąco",
    "dashboard.top 3" : "Top 3",
    "dashboard.média de execuções de receitas por hora" : "Średnia liczba wykonanych przepisów na godzinę",
    "dashboard.avisos" : "OSTRZEŻENIA",
    "dashboard.ver mais" : "Zobacz więcej",
    "dashboard.abertos pela plataforma IOK" : "Otwarte przez platformę IOK",
    "dashboard.equipamentos" : "Urządzenia",
    "dashboard.receitas" : "Przepisy",
    "dashboard.executada" : "przygotowana",
    "dashboard.vezes" : "razy",
    "dashboard.forno" : "Piekarnik",
    "dashboard.média por hora" : "Średnia na godzinę",
    "dashboard.editar" : "edytuj",
    "dashboard.endereço:" : "Adres:",
    "dashboard.cep:" : "Kod pocztowy:",
    "dashboard.estatísticas" : "Statystyki",
    "dashboard.uso de equipamento" : "Użytkowanie urządzenia",
    "dashboard.pico de uso" : "Szczyt użycia",
    "dashboard.receitas mais executadas por equipamento" : "Najczęściej wykonywane przepisy na urządzenie",
    "dashboard.recolher" : "zwiń",
    "dashboard.TOROS TC CONECTADOS:" : "TOROS TC PODŁĄCZONE:",
    "dashboard.Consumo de energia - Lastro Toro TC" : "Zużycie energii – Lastro Toro TC",
    "dashboard.tootilp": "Jest to suma wszystkich receptur zrealizowanych w bieżącym dniu, podzielona przez liczbę godzin pracy pieca.",
    "dashboard.noResults": "Brak wyników :(",
    "dashboard.Preaquecimento": "Podgrzewanie wstępne",
    "dashboard.Esfriamento": "Chłodzenie",
    "dashboard.Execução de receitas": "Przygotowanie receptur",
    "dashboard.Execução de receitas TSi": "Przygotowanie receptur TSi",
    "dashboard.Modo manual": "Tryb ręczny",
    "dashboard.Limpeza": "Czyszczenie",
    "dashboard.Porta": "Drzwi",
    "dashboard.Erros e alertas": "Błędy i alerty",
    "dashboard.Parâmetros": "Parametry",
    "dashboard.SEM DADOS POR AQUI" : "BRAK DANYCH TUTAJ",
    "dashboard.AINDA SEM GRÁFICOS POR AQUI" : "NADAL NIE MA TU WYKRESÓW",
    "dashboard.description.AINDA SEM GRÁFICOS POR AQUI" : "Wybierz elementy z listy obok, aby wygenerować wykresy, lub kliknij w wiersz, aby zobaczyć więcej szczegółów.",
    "dashboard.sem avisos por aqui" : "BRAK POWIADOMIEŃ TUTAJ",
    
    //INFORMAÇÕES IOK
    "iokInformation.search.placeholder" : "Szukaj artykułu",
    "iokInformation.article.openInHelpCenter": "Zobacz artykuł w Centrum pomocy",
    "iokInformation.aboutPlatform.platformFeatures.title": "Platforma i jej funkcjonalności",
    "iokInformation.aboutPlatform.platformFeatures.linkLabel": "Pobierz pełną prezentację",
    "iokInformation.aboutPlatform.manual.title": "Instrukcja obsługi",
    "iokInformation.aboutPlatform.manual.linkLabel": "Pobierz instrukcję",
    "iokInformation.aboutPlatform.privacy.title": "Polityka prywatności",
    "iokInformation.aboutPlatform.privacy.linkLabel": "Pobierz politykę",
    "iokInformation.aboutPlatform.api.title": "Zewnętrzne API",
    "iokInformation.aboutPlatform.api.linkLabel": "Pobierz dokument",
    
    //Telemetry TSI
    "telemetry.EQUIPMENT_TURN_ON": "Urządzenie włączone",
    "telemetry.SENSORS_VALUES": "Wartości czujników",
    "telemetry.ERROR_DETECTED": "Wykryto błąd",
    "telemetry.TIME_ADDED": "Dodano czas",
    "telemetry.GN_ADDED": "Dodano GN",
    "telemetry.GN_RELEASED": "GN rozpoczęty",
    "telemetry.GN_FINISHED": "GN zakończony",
    
    "telemetry.HEAVY_CLEANING_CANCELED": "Mycie intensywne anulowane",
    "telemetry.CLEANING_CANCELED": "Mycie anulowane",
    "telemetry.CLEANING_RESTARTED": "Mycie wznowione",
    "telemetry.CLEANING_VAPORIZATION_STEP": "Etap mycia: Parowanie",
    "telemetry.CLEANING_SUPPLY_STEP": "Etap mycia: Napełnianie",
    "telemetry.CLEANING_CIRCULATION_STEP": "Etap mycia: Cyrkulacja",
    "telemetry.CLEANING_DEPLETION_STEP": "Etap mycia: Opróżnianie",
    "telemetry.CLEANING_RISING_STEP": "Etap mycia: Płukanie",
    "telemetry.CLEANING_STARTED": "Mycie rozpoczęte",
    "telemetry.CLEANING_FINISHED": "Mycie zakończone",
    "telemetry.RECOMMENDED_CLEANING": "Zalecane czyszczenie",
    "telemetry.VALID_PASSWORD_CLEANING": "Prawidłowe hasło do mycia",
    "telemetry.INVALID_PASSWORD_CLEANING": "Nieprawidłowe hasło do mycia",
    
    "telemetry.RECIPE_STARTED": "Przepis rozpoczęty",
    "telemetry.RECIPE_FINISHED": "Przepis zakończony",
    "telemetry.RECIPE_CANCELED": "Przepis anulowany",
    "telemetry.RECIPE_STEP_CHANGED": "Zmiana kroku przepisu",
    "telemetry.RECIPE_PAUSED": "Przepis wstrzymany",
    "telemetry.RECIPE_RESUMED": "Przepis wznowiony",
    "telemetry.RESUME_RECIPE_CANCELED": "Wznowienie przepisu anulowane",
    "telemetry.DROP_ENERGY_SUPPLY": "Wznowienie po zaniku zasilania",
    
    "telemetry.PRE_HEAT_STARTED": "Rozgrzewanie rozpoczęte",
    "telemetry.PRE_HEAT_FINISHED": "Rozgrzewanie zakończone",
    "telemetry.OPERATION_CONTINUE_STARTED": "Kontynuacja pracy rozpoczęta",
    "telemetry.OPERATION_CONTINUE_FINISHED": "Kontynuacja pracy zakończona",
    "telemetry.HOLD_TEMPERATURE_STARTED": "Podtrzymanie temperatury rozpoczęte",
    "telemetry.HOLD_TEMPERATURE_FINISHED": "Podtrzymanie temperatury zakończone",
    "telemetry.COOL_DOWN_STARTED": "Schładzanie rozpoczęte",
    "telemetry.COOL_DOWN_FINISHED": "Schładzanie zakończone",
    "telemetry.NOCTURNAL_COOKING_STARTED": "Pieczenie nocne rozpoczęte",
    "telemetry.NOCTURNAL_COOKING_FINISHED": "Pieczenie nocne zakończone",
    "telemetry.SEALING_STARTED": "Obsmażanie rozpoczęte",
    "telemetry.SEALING_FINISHED": "Obsmażanie zakończone",
    "telemetry.TURBO_GRILL_STARTED": "Turbo Grill rozpoczęty",
    "telemetry.TURBO_GRILL_FINISHED": "Turbo Grill zakończony",
    "telemetry.TURBO_GRILL_ACTIVATED": "Turbo Grill aktywowany",
    "telemetry.TURBO_GRILL_DISABLED": "Turbo Grill dezaktywowany",
    
    "telemetry.MOISTURE_CHANGED": "Zmiana wilgotności",
    "telemetry.TURBINE_CHANGED": "Zmiana prędkości wentylatora",
    "telemetry.SET_POINT_CHANGED": "Zmiana temperatury komory",
    "telemetry.STEAM_CHANGED": "Zmiana pary",
    "telemetry.PROBE_CHANGED": "Zmiana temperatury sondy",
    "telemetry.TIME_CHANGED": "Zmiana czasu",
    "telemetry.DOOR_OPENED": "Drzwi otwarte",
    "telemetry.DOOR_CLOSED": "Drzwi zamknięte",
    
    "telemetry.PROBE_CONTROL_SELECTED": "Wybrano sterowanie sondą",
    "telemetry.TIME_CONTROL_SELECTED": "Wybrano sterowanie czasem",
    "telemetry.MANUAL_STEAM_INJECTED": "Ręczny wtrysk pary",
    "telemetry.AUTOMATIC_STEAM_INJECTED": "Automatyczny wtrysk pary",
    
    "telemetry.DATABASE_CREATED": "Utworzono bazę danych",
    "telemetry.EXIT_FUNCTION": "Wyjście z funkcji",
    "telemetry.CONSUMPTION": "Zużycie",
    "telemetry.STANDBY": "Tryb czuwania",
    
    "telemetry.ANALYTICS_ERROR_BAD_REQUEST": "Błąd analityki: Nieprawidłowe żądanie",
    "telemetry.ANALYTICS_ERROR_FORBIDDEN": "Błąd analityki: Brak dostępu",
    "telemetry.ANALYTICS_ERROR_SERVER": "Błąd analityki: Awaria serwera",
    "telemetry.ANALYTICS_ERROR_UNEXPECTED": "Błąd analityki: Nieoczekiwany błąd",
    "telemetry.ANALYTICS_SUCCESS": "Sukces analityki",
    
    "telemetry.STEP": "Krok",
    "telemetry.STEAM": "Para",
    "telemetry.PROBE": "Sonda",
    "telemetry.TURBINE": "Turbina",
    "telemetry.OCCURRENCES": "wystąpienia",
    "telemetry.FUNC_USER_RECIPE": "Przepis użytkownika",
    "telemetry.FUNC_TSI_RECIPE": "Przepis TSi",
    "telemetry.FUNC_DELTA_T": "Delta T",
    "telemetry.FUNC_STEAM": "Para",
    "telemetry.FUNC_COMBINED_STEAM": "Para kombinowana",
    "telemetry.FUNC_HOT_AIR": "Gorące powietrze",
    "telemetry.FUNC_NOCTURNAL_COOKING": "Gotowanie nocne",
    "telemetry.FUNC_REGENERATE": "Regeneracja",
    "telemetry.FUNC_MULTIPLE_COOKING": "Gotowanie wieloetapowe",
    
    "haccp.filterBy": "Filtruj według",
    "haccp.voltage": "Napięcie",
    "haccp.voltageReading": "Odczyt napięcia",
    "haccp.voltageOscillation": "Wahania napięcia w ciągu dnia",
    "haccp.status.normal": "Normalny",
    "haccp.status.attention": "Uwaga",
    "haccp.status.critical": "Krytyczny",
    "haccp.dateTime": "Data/Godzina",
    "haccp.errorDetected": "Wykryto błąd/alert",
    "haccp.detected": "wykryto",
    "haccp.errorTypeLabel": "Typ błędu/alertu",
    "haccp.severityLabel": "Poziom",
    "haccp.severity.error": "Błąd",
    "haccp.severity.alert": "Alert",
    "haccp.error.canNetwork": "Błąd sieci CAN",
    "haccp.error.chamberSensor": "Błąd czujnika komory",
    "haccp.error.steamSensor": "Błąd czujnika pary",
    "haccp.error.probeSensor": "Błąd sondy",
    "haccp.error.noWater": "Błąd braku wody",
    "haccp.error.panelTemp": "Błąd temp. panelu",
    "haccp.error.motor": "Błąd silnika",
    "haccp.error.motorComm": "Błąd komunik. silnika",
    "haccp.error.hygieneIncomplete": "Błąd niepełnej higieny",
    "haccp.error.familyModel": "Błąd rodziny/modelu",
    "haccp.error.boardTemp": "Błąd temp. płyty",
    "haccp.error.energyModule": "Błąd modułu energii",
    "haccp.error.i2c": "Błąd I2C",
    "haccp.error.gas": "Błąd gazu",
    "haccp.export.generating": "Arkusz HACCP jest generowany i wkrótce zostanie automatycznie pobrany.",
    "haccp.loading": "Ładowanie...",
    "haccp.quantity": "Ilość",
    "haccp.executions": "Przygotowania",
    "haccp.manual.mode": "Tryb",
    "haccp.manual.tempC": "Temp (°C)",
    "haccp.manual.timeMin": "Czas (min)",
    "haccp.manual.probeC": "Sonda (°C)",
    "haccp.manual.steamPct": "Para %",
    "haccp.cleaning.label": "Czyszczenie",
    "haccp.cleaning.recommendedLabel": "Zalecane czyszczenie",
    "haccp.cleaning.status.completed": "Zakończono",
    "haccp.cleaning.status.restarted": "Uruchomiono ponownie",
    "haccp.cleaning.status.interrupted": "Przerwano",
    "haccp.status.label": "Status",
    "haccp.error": "Błąd",
    "haccp.consumption.water": "Zużycie wody",
    "haccp.consumption.energy": "Zużycie energii",
    "haccp.short.temp": "Temp",
    "haccp.short.time": "Czas",
    "haccp.day": "Dzień",
    "haccp.recipeExecutions": "Liczba przygotowań",
    "STEAM": "Para",
    "COMBINED_STEAM": "Para kombinowana",
    "PROBE": "Sonda",
    "TURBINE": "Turbina",
    "HOT_AIR": "Gorące powietrze",
    "NOCTURNAL_COOKING": "Gotowanie nocne",
    "REGENERATE": "Regeneracja",
    "MULTIPLE_COOKING": "Wieloetapowe gotowanie",
    "DELTA_T": "Delta T",
    
    //CSAT
    "csat.AVALIE SUA EXPERIÊNCIA": "OCEŃ SWOJE DOŚWIADCZENIE",
    "csat.Como você avalia sua experiência com": "Jak oceniasz swoje doświadczenie z",
    "csat.Muito insatisfeito": "Bardzo niezadowolony",
    "csat.Insatisfeito": "Niezadowolony",
    "csat.Neutro": "Neutralny",
    "csat.Satisfeito": "Zadowolony",
    "csat.Muito satisfeito": "Bardzo zadowolony",
    "csat.Utilize o espaço abaixo para deixar suas sugestões:": "Skorzystaj z poniższego pola, aby zostawić swoje sugestie:",
    "csat.Digite aqui": "Wpisz tutaj",
    "csat.Obrigado por responder à nossa pesquisa!": "Dziękujemy za udział w naszej ankiecie!",
    "csat.Selecione uma nota para continuar": "Wybierz ocenę, aby kontynuować",
    "csat.Enviar": "Wyślij",
    "csat.a criação de receitas": "tworzenie receptur",
    "csat.o cadastro de equipamentos": "rejestracja urządzeń",
    "csat.o cadastro de usuários": "rejestracja użytkowników",
    "csat.a criação de menus": "tworzenie menu",
    "csat.a deleção de receitas": "usuwanie receptur",
    "csat.a reordenação de receitas": "zmiana kolejności receptur",
    "csat.o envio de software": "wysyłanie oprogramowania",
    "csat.o envio de menus": "wysyłanie menu",
    "csat.o uso de receitas do Cookbook": "korzystanie z przepisów z Cookbooka",
  },
};

export default pl;

